import React, { forwardRef } from 'react';
import ServiceLog from './ServiceLog';
import moment from 'moment';
import http from 'utils/http';
import styles from '../../../../../custom/style.module.css';
import fltLoadInfoStyles from '../flightloadinfo/fltloadinfo.module.css';
// import { DateFormat, MonthFormat } from 'custom/constants';
import cookies from 'utils/cookies';
import { contractType, pageHandler } from 'custom/constants';
import cloneDeep from 'lodash/cloneDeep';
import { toast } from 'react-toastify';
import { handleExport } from '../exportExcel';

// const timezone = cookies.get('timezone') || null;

class ServiceLogContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // airlines: [],
      // searchFields: {
      //   // from: moment().tz(timezone).format('YYYY-MM-DD'),
      //   // to: moment().add(1,'days').tz(timezone).format('YYYY-MM-DD'),
      //   month: moment().tz(timezone).format('YYYY-MM'),
      //   period: 'month',
      //   airline: null
      // },
      // contract_Type: null,
      genInvProgress: false,
      userContractTypes: this.props.userContractTypes,
      contract_Type: this.props.contract_Type,
      cont_item: this.props.cont_item,
      airlines: this.props.airlines,
      searchFields: this.props.searchFields,
      airlineCode: this.props.airlineCode,
      
      serviceLog: [],
      historyData: [],
      modalOpen: false,
      expanded: '',
      day: '',
      billingFields: {},
      flightdata: [],
      daylogdata: [],
      monthlogdata: [],
      alcontractsData: [],
      contractData: [],
      dayContractData: [],
      monthContractData: [],
      invoice_info: null,
      accord_id: null,
      accord_type: null,
      anchorEl: null,
      progress: 10,
      modal: false,
      timer: null,
      sessionExpired: false,
      emailPassword: false,

      contractData2: [],
      daylogdata2: [],
      monthlogdata2: [],
      products: [],
      activeProd: null,
      filteredData: [],
      csvContracts: [],
      filterData: { },
      reportFields: { reportType: 'full' },
      customReportOptions: [],
      tonSumOpts: [],
      flightSumOpts: [],
      flightDetOpts: [],
      billingData: [],
      billingData2: [],
      billingColumns: [],
      flightList: [],
      statisticsSummary: false,
    };
    this.station_code = cookies.get('station_code') || null;
    this.interval = null;
  }
  componentDidMount() {
    this.startTimer();
    this.getConfig();
    console.log('ServiceLogContainer.js componentDidMount()');
    const currentPath = window.location.pathname;
    pageHandler(currentPath, cookies.get('role'));
    // this.eventSource = events('admin', 'method');
    // this.fetchUser();
    // this.fetchContractData();
    this.fetchInvoiceData();
    // this.fetchAirlines();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  getConfig = () => {
    http.get('/settings?key=statistics_summary').then(({ data }) => {
      if(data.data) {
        let Summary = data.data?.find((item) => item.key === 'statistics_summary');
        if(Summary) {
          this.setState({ statisticsSummary: Summary?.value && Summary.value?.data === 'true'? true: false });
        }
      }
    });
  };

  fetchProducts = ( callType=null, callback) => {
    if (!callType || this.state.billingColumns.length === 0) {
      this.setState({
        products: [],
        activeProd: null,
      });
      http.get(`/products?airlineId=${this.state.searchFields?.airline}`)
        .then(response => {
          const { data } = response;
          if (data.status === 'success') {
            if (data.data && data.data.length > 0) {
              this.setState({
                products: data.data,
                activeProd: data.data[0],
              }, () => {
                this.generateBillingColumns('fetch', (v) => {
                  console.log('generateBillingColumns', v);
                  return callback && callback(true, this.state.billingData2, this.state.billingColumns);
                });
              });
            } else {
              this.setState({
                activeProd: null,
                products: []
              }, () => {
                this.generateBillingColumns('fetch', (v) => {
                  console.log('generateBillingColumns', v);
                  return callback && callback(true, this.state.billingData2, this.state.billingColumns);
                });
              });
            }
          }
        })
        .catch(error => {
          this.setState({ products: [] });
          console.error('Error fetching data:', error);
          return callback && callback(false);
        });
    } else {
      return callback && callback(true, cloneDeep(this.state.billingData2), cloneDeep(this.state.billingColumns));
    }
  };

  fetchDiscrepancies = (type = null, callType = null, callback = null) => {
    if(callType){
      // Ignore, nothing special to do here
    }
    let from = moment(this.state.searchFields.from).format('YYYY-MM-DD');
    let to = moment(this.state.searchFields.to).format('YYYY-MM-DD');
    if (this.state.searchFields.month) {
      if (this.state.searchFields.period === 'month') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      } else if (this.state.searchFields.period === 'first') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(14, 'days').format('YYYY-MM-DD');
      } else {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(15, 'days').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      }
    }
    let dateType = 'scheduled';
    if(this.state.billingFields.dateType === 'actual'){
      dateType = 'actual';
    }
    if (this.state.searchFields.airline) {
      http.get(`/billing/discrepancy?from=${from}&to=${to}&station=${this.station_code}&airline=${this.state.searchFields.airline}&datetype=${dateType}`)
        .then(({ data }) => {
          console.log('setting flightList 1',data.data.length);
          // if(!callType)
          this.setState({ flightList: data.data });
          let discrepancyCountInbound = data.data[0]?.inbound.map((inbound) => inbound?.flight_discrepancies.length).reduce((a, b) => a + b, 0);
          let discrepancyCountOutbound = data.data[0]?.outbound.map((outbound) => outbound?.flight_discrepancies.length).reduce((a, b) => a + b, 0);
          let discrepancyCount = discrepancyCountInbound + discrepancyCountOutbound;
          if (type === 'count') {
            // if(!callType)
            this.setState({ discrepancyCount });
          }
          else {
            if (data.data && data.data.length > 0) {
              let billingData2 = [];
              data.data.forEach((airline) => {
                let inbound = {};
                let outbound = {};
                let inbound_data = [];
                let outbound_data = [];

                let ib_flight_count = 0;

                if (airline?.inbound?.length > 0) {
                  ib_flight_count = airline?.inbound?.length;
                  airline?.inbound.map((inflight) => {
                    let flight_discrepancies = inflight?.flight_discrepancies || [];
                    let flight = {
                      id: inflight?.id,
                      row_id: inflight?.id,
                      flight_no: inflight?.flight_no,
                      label: `${airline?.code}${inflight?.flight_no}/${moment(inflight?.flight_date, 'YYYY-MM-DD').format('DDMMMYY')}`,
                      act_arr: inflight?.act_arr,
                      act_dept: inflight?.act_dept,
                      schdl_arr: inflight?.schdl_arr,
                      schdl_dept: inflight?.schdl_dept,
                      start_dt: inflight?.start_dt,
                      end_dt: inflight?.end_dt,
                      type: inflight?.type,
                      org: inflight?.org,
                      dest: inflight?.dest,
                      url: `/flight_folder/discrepancies?id=${inflight.id}`,
                      flight_schedule_id: inflight?.flight_schedule_id,
                      flight_count: 1,
                      contractData: flight_discrepancies,
                    };
                    inbound_data.push(flight);
                  });
                }
                let inboundData = inbound_data.map(obj => obj.contractData).flat();
                let inboundDiscType = [];
                inboundData?.map((discrepancy) => {
                  inboundDiscType.push(discrepancy.type);
                });
                let typeObj = {
                  'Missing Airwaybill': 0,
                  'Missing Cargo': 0,
                  'Found Cargo': 0,
                  'Found Airwaybill': 0,
                  'Short Shipped': 0,
                  'Over Carried': 0,
                  'Damaged Cargo': 0,
                  'Other': 0
                };
                inboundDiscType.forEach(type => {
                  if (typeObj[type]) {
                    typeObj[type]++;
                  }
                  else {
                    typeObj[type] = 1;
                  }
                });
                inbound = {
                  id: `${airline?.id}_inbound`,
                  label: `${ib_flight_count} Inbound Flights`,
                  flight_count: ib_flight_count,
                  flights: inbound_data,
                  contractData: inbound_data.map(obj => obj.contractData).flat(),
                  ...typeObj
                };

                let ob_flight_count = 0;

                if (airline?.outbound?.length > 0) {
                  ob_flight_count = airline?.outbound?.length;
                  airline?.outbound.map((outflight) => {
                    let flight_discrepancies = outflight?.flight_discrepancies || [];
                    let flight = {
                      id: outflight?.id,
                      row_id: outflight?.id,
                      flight_no: outflight?.flight_no,
                      label: `${airline?.code}${outflight?.flight_no}/${moment(outflight?.flight_date, 'YYYY-MM-DD').format('DDMMMYY')}`,
                      act_arr: outflight?.act_arr,
                      act_dept: outflight?.act_dept,
                      schdl_arr: outflight?.schdl_arr,
                      schdl_dept: outflight?.schdl_dept,
                      start_dt: outflight?.start_dt,
                      end_dt: outflight?.end_dt,
                      type: outflight?.type,
                      org: outflight?.org,
                      dest: outflight?.dest,
                      url: `/flight_folder/discrepancies?id=${outflight.id}`,
                      flight_schedule_id: outflight?.flight_schedule_id,
                      flight_count: 1,
                      contractData: flight_discrepancies,
                    };
                    outbound_data.push(flight);

                  });
                }

                let outboundData = outbound_data.map(obj => obj.contractData).flat();
                let outDiscType = [];
                outboundData?.map((discrepancy) => {
                  outDiscType.push(discrepancy.type);
                });
                let outTypeObj = {
                  'Missing Airwaybill': 0,
                  'Missing Cargo': 0,
                  'Found Cargo': 0,
                  'Found Airwaybill': 0,
                  'Short Shipped': 0,
                  'Over Carried': 0,
                  'Damaged Cargo': 0,
                  'Other': 0
                };
                outDiscType.forEach(type => {
                  if (outTypeObj[type]) {
                    outTypeObj[type]++;
                  }
                  else {
                    outTypeObj[type] = 1;
                  }
                });
                outbound = {
                  id: `${airline?.id}_outbound`,
                  label: `${ob_flight_count} Outbound Flights`,
                  flight_count: ob_flight_count,
                  flights: outbound_data,
                  contractData: outbound_data.map(obj => obj.contractData).flat(),
                  ...outTypeObj
                };

                let airline_data = {
                  id: airline?.id,
                  label: `${parseInt(ib_flight_count) + parseInt(ob_flight_count)} ${airline?.code} Flights`,
                  flight_count: ib_flight_count + ob_flight_count,
                  inbound: inbound,
                  outbound: outbound,
                  contractData: [...inbound.contractData, ...outbound.contractData],
                  'Missing Airwaybill': inbound['Missing Airwaybill'] + outbound['Missing Airwaybill'] || 0,
                  'Missing Cargo': inbound['Missing Cargo'] + outbound['Missing Cargo'] || 0,
                  'Found Cargo': inbound['Found Cargo'] + outbound['Found Cargo'] || 0,
                  'Found Airwaybill': inbound['Found Airwaybill'] + outbound['Found Airwaybill'] || 0,
                  'Short Shipped': inbound['Short Shipped'] + outbound['Short Shipped'] || 0,
                  'Over Carried': inbound['Over Carried'] + outbound['Over Carried'] || 0,
                  'Damaged Cargo': inbound['Damaged Cargo'] + outbound['Damaged Cargo'] || 0,
                  'Other': inbound['Other'] + outbound['Other'] || 0,
                };
                billingData2.push(airline_data);
              });
              let contractData = [];
              let accord_id = null;
              let accord_type = null;
              if (billingData2.length > 0) {
                contractData = billingData2[0]?.contractData;
                accord_id = billingData2[0]?.id;
                accord_type = 'airline';
              }
              this.setState({
                billingData2: billingData2,
                contractData2: contractData,
                accord_id: accord_id,
                accord_type: accord_type,
                discrepancyCount
              }, () => {
                this.filter();
                if (this.state.billingFields.transit === 'inbound' || this.state.billingFields.transit === 'outbound') {
                  this.filterData();
                  if (callback)
                    return callback(true, data.data);
                } else {
                  if (callback) {
                    this.filterData();
                    return callback(true, data.data);
                  }
                }
              });
            } else {
              // this.setState({ billingData2: [] });
              if (callback)
                return callback(true, data.data);
            }
          }
        });
    }
  };

  fetchBillingReport = (callback) => {
    let from = this.state.searchFields.from;
    let to = this.state.searchFields.to;
    if (this.state.searchFields.month) {
      if (this.state.searchFields.period === 'month') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      } else if (this.state.searchFields.period === 'first') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(14, 'days').format('YYYY-MM-DD');
      } else {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(15, 'days').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      }
    }
    let dateType = 'scheduled';
    if(this.state.billingFields.dateType === 'actual'){
      dateType = 'actual';
    }
    if (from && to && this.state.searchFields.airline) {
      http.get(`/billing?from=${from}&to=${to}&station=${this.station_code}&airline=${this.state.searchFields.airline}&type=${this.state.cont_item}&datetype=${dateType}`)
        .then(({ data }) => {
          console.log('setting flightList 2',data.data.length);
          this.setState({ flightList: data.data });
          if (data.data && data.data.length > 0) {
            let billingData2 = [];
            data.data.forEach((airline) => {

              let inbound = {};
              let outbound = {};
              let inbound_data = [];
              let outbound_data = [];

              let ib_flight_count = 0;
              let ib_awb_count = 0;
              let ib_awb_count_disc = 0;
              let ib_sum_awb_local = 0;
              let ib_sum_awb_local_disc = 0;
              let ib_sum_awb_export = 0;
              let ib_sum_awb_export_disc = 0;
              let ib_sum_awb_transit = 0;
              let ib_sum_awb_transit_disc = 0;
              let ib_sum_awb_bup = 0;
              let ib_sum_awb_comat = 0;
              let ib_sum_manifested = 0;
              let ib_prodvals = cloneDeep(this.state.prodkeys).map((rec) => {
                return {
                  key: rec.key,
                  id: rec.id,
                  sum: 0
                };
              });
              let ib_prodvals_disc = cloneDeep(this.state.prodkeysDisc).map((rec) => {
                return {
                  key: rec.key,
                  id: rec.id,
                  sum: 0
                };
              });

              let ib_awbs = [];
              let ob_awbs = [];

              if (airline?.inbound?.length > 0) {
                ib_flight_count = airline?.inbound?.length;
                airline?.inbound.map((inflight) => {
                  let distinct_awbs = [];
                  let flight_discrepancies = inflight?.flight_discrepancies || [];
                  let awb_count = 0;
                  let awb_count_disc = 0;
                  let sum_awb_local = 0;
                  let sum_awb_local_disc = 0;
                  let sum_awb_export = 0;
                  let sum_awb_export_disc = 0;
                  let sum_awb_transit = 0;
                  let sum_awb_transit_disc = 0;
                  let sum_awb_bup = 0;
                  let sum_awb_comat = 0;
                  let sum_manifested = 0;
                  let sum_prodvals = cloneDeep(this.state.prodkeys).map((rec) => {
                    return {
                      key: rec.key,
                      id: rec.id,
                      sum: 0
                    };
                  });
                  let sum_prodvals_disc = cloneDeep(this.state.prodkeysDisc).map((rec) => {
                    return {
                      key: rec.key,
                      id: rec.id,
                      sum: 0
                    };
                  });
                  let awbs = [];
                  //Map ULDs
                  if (inflight?.flight_uld.length > 0) {
                    inflight?.flight_uld.map((uld) => {

                      if (uld?.flight_awbs.length > 0) {
                        uld?.flight_awbs.map((awb) => {
                          let found = false;
                          if (distinct_awbs.includes(awb?.awb_no)) {
                            found = true;
                          } else {
                            distinct_awbs.push(awb?.awb_no);
                          }
                          let awb_data = {
                            id: awb?.id,
                            awb_no: awb?.awb_no,
                            label: awb?.awb_no,
                            flight_count: '-',
                            awb_count: 0,
                            awb_count_disc: 0,
                            sum_awb_local: 0,
                            sum_awb_local_disc: 0,
                            sum_awb_export: 0,
                            sum_awb_export_disc: 0,
                            sum_awb_transit: 0,
                            sum_awb_transit_disc: 0,
                            sum_awb_bup: 0,
                            sum_awb_comat: 0,
                            sum_manifested: 0,
                          };
                          if (awb?.dest === this.station_code) {
                            sum_awb_local += parseFloat(awb?.wgt || 0);
                            sum_awb_local_disc += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_local = parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_local_disc = parseFloat(awb?.wgt || 0);
                          } else if (awb?.org === this.station_code) {
                            sum_awb_export += parseFloat(awb?.wgt || 0);
                            sum_awb_export_disc += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_export = parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_export_disc = parseFloat(awb?.wgt || 0);
                          } else if (awb?.org && awb?.dest) {
                            sum_awb_transit += parseFloat(awb?.wgt || 0);
                            sum_awb_transit_disc += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_transit = parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_transit_disc = parseFloat(awb?.wgt || 0);
                          }
                          if (awb?.type === 'BUP') {
                            sum_awb_bup += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_bup = parseFloat(awb?.wgt || 0);
                          } else if (awb?.type === 'COMAT') {
                            sum_awb_comat += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_comat = parseFloat(awb?.wgt || 0);
                          }
                          if (awb) {
                            awb_count += found ? 0 : 1;
                            awb_count_disc += found ? 0 : 1;
                            awb_data.awb_count = found ? 0 : 1;
                            awb_data.awb_count_disc = found ? 0 : 1;

                            sum_manifested += parseFloat(awb?.wgt || 0);
                            awb_data.sum_manifested = parseFloat(awb?.wgt || 0);
                          }
                          sum_prodvals.map((rec) => {
                            // Check if awb.products contains a product with matching id
                            const hasProduct = Array.isArray(awb?.products) && awb.products.some(product => product.id === rec.id);
                            if (hasProduct) {
                              rec.sum += 1;
                              awb_data[rec.key] = 1;
                            } else {
                              awb_data[rec.key] = 0;
                            }
                          });
                          sum_prodvals_disc.map((rec) => {
                            // Check if awb.products contains a product with matching id
                            const hasProduct = Array.isArray(awb?.products) && awb.products.some(product => product.id === rec.id);
                            if (hasProduct) {
                              rec.sum += 1;
                              awb_data[rec.key] = 1;
                            } else {
                              awb_data[rec.key] = 0;
                            }
                          });
                          awbs.push(awb_data);
                          ib_awbs.push({ awb_no: awb?.awb_no });
                        });
                      }
                    });
                  }
                  if (flight_discrepancies.length > 0) {
                    flight_discrepancies.map((rec) => {
                      let found = false;
                      if (distinct_awbs.includes(rec?.awb_no)) {
                        found = true;
                      } else {
                        distinct_awbs.push(rec?.awb_no);
                      }
                      if (rec?.type === 'Missing Cargo' || rec?.type === 'Short Shipped') {
                        let awb_data = {
                          id: rec?.id,
                          awb_no: rec?.awb_no,
                          label: <>{rec?.awb_no} &nbsp; <span className={fltLoadInfoStyles.discType}>{rec?.type}</span></>,
                          flight_count: '-',
                          awb_count_disc: 0,
                          sum_awb_local_disc: 0,
                          sum_awb_export_disc: 0,
                          sum_awb_transit_disc: 0,
                          sum_manifested: 0,
                          prod_code: rec?.prod_code,
                          products: rec?.products || [],
                        };
                        sum_prodvals_disc.map((rec1) => {
                          // Check if awb.products contains a product with matching id
                          const hasProduct = Array.isArray(awb_data?.products) && awb_data.products.some(product => product.id === rec1.id);
                          if (hasProduct) {
                            rec1.sum += 1;
                            awb_data[rec1.key] = 1;
                          } else {
                            awb_data[rec1.key] = 0;
                          }
                        });

                        if (rec?.dest === this.station_code) {
                          awb_data.awb_count_disc += found ? 0 : 1;
                          awb_count_disc += found ? 0 : 1;
                          awb_data.sum_awb_local_disc -= parseFloat(rec?.d_wgt);
                          sum_awb_local_disc -= parseFloat(rec?.d_wgt);
                        } else if (rec?.org === this.station_code) {
                          awb_data.awb_count_disc += found ? 0 : 1;
                          awb_count_disc += found ? 0 : 1;
                          awb_data.sum_awb_export_disc -= parseFloat(rec?.d_wgt);
                          sum_awb_export_disc -= parseFloat(rec?.d_wgt);
                        } else if (rec?.org && rec?.dest) {
                          awb_data.awb_count_disc += found ? 0 : 1;
                          awb_count_disc += found ? 0 : 1;
                          awb_data.sum_awb_transit_disc -= parseFloat(rec?.d_wgt);
                          sum_awb_transit_disc -= parseFloat(rec?.d_wgt);
                        }
                        awbs.push(awb_data);
                        ib_awbs.push({ awb_no: rec?.awb_no });
                      } else if (rec?.type === 'Found Cargo' || rec?.type === 'Over Carried') {
                        let awb_data = {
                          id: rec?.id,
                          awb_no: rec?.awb_no,
                          label: <>{rec?.awb_no} &nbsp; <span className={fltLoadInfoStyles.discType}>{rec?.type}</span></>,
                          flight_count: '-',
                          awb_count_disc: 0,
                          sum_awb_local_disc: 0,
                          sum_awb_export_disc: 0,
                          sum_awb_transit_disc: 0,
                          sum_manifested: 0,
                          prod_code: rec?.prod_code,
                          products: rec?.products || [],
                        };

                        sum_prodvals_disc.map((rec1) => {
                          // Check if awb.products contains a product with matching id
                          const hasProduct = Array.isArray(awb_data?.products) && awb_data.products.some(product => product.id === rec1.id);
                          if (hasProduct) {
                            rec1.sum += 1;
                            awb_data[rec1.key] = 1;
                          } else {
                            awb_data[rec1.key] = 0;
                          }
                        });
                        if (rec?.dest === this.station_code) {
                          awb_data.awb_count_disc += found ? 0 : 1;
                          awb_count_disc += found ? 0 : 1;
                          awb_data.sum_awb_local_disc += parseFloat(rec?.d_wgt);
                          sum_awb_local_disc += parseFloat(rec?.d_wgt);
                        } else if (rec?.org === this.station_code) {
                          awb_data.awb_count_disc += found ? 0 : 1;
                          awb_count_disc += found ? 0 : 1;
                          awb_data.sum_awb_export_disc += parseFloat(rec?.d_wgt);
                          sum_awb_export_disc += parseFloat(rec?.d_wgt);
                        } else if (rec?.org && rec?.dest) {
                          awb_data.awb_count_disc += found ? 0 : 1;
                          awb_count_disc += found ? 0 : 1;
                          awb_data.sum_awb_transit_disc += parseFloat(rec?.d_wgt);
                          sum_awb_transit_disc += parseFloat(rec?.d_wgt);
                        }
                        awbs.push(awb_data);
                        ib_awbs.push({ awb_no: rec?.awb_no });
                      }
                    });
                  }

                  let flight = {
                    id: inflight?.id,
                    flight_no: inflight?.flight_no,
                    label: `${airline?.code}${inflight?.flight_no}/${moment(inflight?.flight_date, 'YYYY-MM-DD').format('DDMMMYY')}`,
                    act_arr: inflight?.act_arr,
                    act_dept: inflight?.act_dept,
                    schdl_arr: inflight?.schdl_arr,
                    schdl_dept: inflight?.schdl_dept,
                    start_dt: inflight?.start_dt,
                    end_dt: inflight?.end_dt,
                    type: inflight?.type,
                    org: inflight?.org,
                    dest: inflight?.dest,
                    url: `/flight_folder/notes?id=${inflight.id}`,
                    flight_schedule_id: inflight?.flight_schedule_id,
                    contractData: awbs,
                    flight_count: 1,
                    awb_count: awb_count,
                    awb_count_disc: awb_count_disc,
                    sum_awb_local: sum_awb_local,
                    sum_awb_local_disc: sum_awb_local_disc,
                    sum_awb_export: sum_awb_export,
                    sum_awb_export_disc: sum_awb_export_disc,
                    sum_awb_transit: sum_awb_transit,
                    sum_awb_transit_disc: sum_awb_transit_disc,
                    sum_awb_bup: sum_awb_bup,
                    sum_awb_comat: sum_awb_comat,
                    sum_manifested: sum_manifested,
                    subRows: awbs,
                    reports: inflight?.reports || [],
                  };
                  sum_prodvals.map((rec) => {
                    flight[rec.key] = rec.sum;
                  });
                  sum_prodvals_disc.map((rec) => {
                    flight[rec.key] = rec.sum;
                  });

                  ib_awb_count += awb_count;
                  ib_awb_count_disc += awb_count_disc;
                  ib_sum_awb_local += sum_awb_local;
                  ib_sum_awb_local_disc += sum_awb_local_disc;
                  ib_sum_awb_export += sum_awb_export;
                  ib_sum_awb_export_disc += sum_awb_export_disc;
                  ib_sum_awb_transit += sum_awb_transit;
                  ib_sum_awb_transit_disc += sum_awb_transit_disc;
                  ib_sum_awb_bup += sum_awb_bup;
                  ib_sum_awb_comat += sum_awb_comat;
                  ib_sum_manifested += sum_manifested;
                  ib_prodvals.map((rec) => {
                    rec.sum += flight[rec.key];
                  });
                  ib_prodvals_disc.map((rec) => {
                    rec.sum += flight[rec.key];
                  });
                  inbound_data.push(flight);
                });
              }
              let inboundgroupedDataArr = inbound_data.reduce((acc, obj) => {
                let key = `${airline?.code}${obj.flight_no}`;
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});
              let inboundParent = [];  // Flight Num grouping
              if (Object.keys(inboundgroupedDataArr).length > 0) {
                Object.entries(inboundgroupedDataArr).map(([key, rec]) => {
                  let inboundParentObj = {
                    label: key,
                    flight_count: 0,
                    awb_count: 0,
                    awb_count_disc: 0,
                    sum_awb_local: 0,
                    sum_awb_local_disc: 0,
                    sum_awb_export: 0,
                    sum_awb_export_disc: 0,
                    sum_awb_transit: 0,
                    sum_awb_transit_disc: 0,
                    sum_awb_bup: 0,
                    sum_awb_comat: 0,
                    sum_manifested: 0,
                    subRows: rec,
                  };
                  if (rec && rec.length > 0) {
                    rec.map((rec) => {
                      inboundParentObj.flight_count += rec.flight_count;
                      inboundParentObj.awb_count += rec.awb_count;
                      inboundParentObj.awb_count_disc += rec.awb_count_disc;
                      inboundParentObj.sum_awb_local += rec.sum_awb_local;
                      inboundParentObj.sum_awb_local_disc += rec.sum_awb_local_disc;
                      inboundParentObj.sum_awb_export += rec.sum_awb_export;
                      inboundParentObj.sum_awb_export_disc += rec.sum_awb_export_disc;
                      inboundParentObj.sum_awb_transit += rec.sum_awb_transit;
                      inboundParentObj.sum_awb_transit_disc += rec.sum_awb_transit_disc;
                      inboundParentObj.sum_awb_bup += rec.sum_awb_bup;
                      inboundParentObj.sum_awb_comat += rec.sum_awb_comat;
                      inboundParentObj.sum_manifested += rec.sum_manifested;
                    });
                  }
                  inboundParent.push(inboundParentObj);
                });
              }
              inbound = {
                id: `${airline?.id}_inbound`,
                label: `${ib_flight_count} Inbound Flights`,
                ex_label: 'Import',
                flight_count: ib_flight_count,
                flights: inbound_data,
                contractData: inbound_data?.map(obj => obj.subRows).flat(),
                awb_count: ib_awb_count,
                awb_count_disc: ib_awb_count_disc,
                sum_awb_local: ib_sum_awb_local,
                sum_awb_local_disc: ib_sum_awb_local_disc,
                sum_awb_export: ib_sum_awb_export,
                sum_awb_export_disc: ib_sum_awb_export_disc,
                sum_awb_transit: ib_sum_awb_transit,
                sum_awb_transit_disc: ib_sum_awb_transit_disc,
                sum_awb_bup: ib_sum_awb_bup,
                sum_awb_comat: ib_sum_awb_comat,
                sum_manifested: ib_sum_manifested,
                subRows: inboundParent,
                ib_awbs: ib_awbs,
              };
              ib_prodvals.map((rec) => {
                inbound[rec.key] = rec.sum;
              });
              ib_prodvals_disc.map((rec) => {
                inbound[rec.key] = rec.sum;
              });


              let ob_flight_count = 0;
              let ob_awb_count = 0;
              let ob_awb_count_disc = 0;
              let ob_sum_awb_local = 0;
              let ob_sum_awb_local_disc = 0;
              let ob_sum_awb_export = 0;
              let ob_sum_awb_export_disc = 0;
              let ob_sum_awb_transit = 0;
              let ob_sum_awb_transit_disc = 0;
              let ob_sum_awb_bup = 0;
              let ob_sum_awb_comat = 0;
              let ob_sum_manifested = 0;
              let ob_prodvals = cloneDeep(this.state.prodkeys).map((rec) => {
                return {
                  key: rec.key,
                  id: rec.id,
                  sum: 0
                };
              });
              let ob_prodvals_disc = cloneDeep(this.state.prodkeysDisc).map((rec) => {
                return {
                  key: rec.key,
                  id: rec.id,
                  sum: 0
                };
              });

              if (airline?.outbound?.length > 0) {
                ob_flight_count = airline?.outbound?.length;
                airline?.outbound.map((outflight) => {
                  let flight_discrepancies = outflight?.flight_discrepancies;
                  let distinct_awbs = [];
                  let awb_count = 0;
                  let awb_count_disc = 0;
                  let sum_awb_local = 0;
                  let sum_awb_local_disc = 0;
                  let sum_awb_export = 0;
                  let sum_awb_export_disc = 0;
                  let sum_awb_transit = 0;
                  let sum_awb_transit_disc = 0;
                  let sum_awb_bup = 0;
                  let sum_awb_comat = 0;
                  let sum_manifested = 0;
                  let sum_prodvals = cloneDeep(this.state.prodkeys).map((rec) => {
                    return {
                      key: rec.key,
                      id: rec.id,
                      sum: 0
                    };
                  });
                  let sum_prodvals_disc = cloneDeep(this.state.prodkeysDisc).map((rec) => {
                    return {
                      key: rec.key,
                      id: rec.id,
                      sum: 0
                    };
                  });
                  let awbs = [];
                  //Map ULDs
                  if (outflight?.flight_uld.length > 0) {
                    outflight?.flight_uld.map((uld) => {

                      if (uld?.flight_awbs.length > 0) {
                        uld?.flight_awbs.map((awb) => {
                          let found = false;
                          if (distinct_awbs.includes(awb?.awb_no)) {
                            found = true;
                          } else {
                            distinct_awbs.push(awb?.awb_no);
                          }
                          let awb_data = {
                            id: awb?.id,
                            awb_no: awb?.awb_no,
                            label: awb?.awb_no,
                            flight_count: '-',
                            awb_count: 0,
                            awb_count_disc: 0,
                            sum_awb_local: 0,
                            sum_awb_local_disc: 0,
                            sum_awb_export: 0,
                            sum_awb_export_disc: 0,
                            sum_awb_transit: 0,
                            sum_awb_transit_disc: 0,
                            sum_awb_bup: 0,
                            sum_awb_comat: 0,
                            sum_manifested: 0,
                          };
                          if (awb?.dest === this.station_code) {
                            sum_awb_local += parseFloat(awb?.wgt || 0);
                            sum_awb_local_disc += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_local = parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_local_disc = parseFloat(awb?.wgt || 0);
                          } else if (awb?.org === this.station_code) {
                            sum_awb_export += parseFloat(awb?.wgt || 0);
                            sum_awb_export_disc += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_export = parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_export_disc = parseFloat(awb?.wgt || 0);
                          } else if (awb?.org && awb?.dest) {
                            sum_awb_transit += parseFloat(awb?.wgt || 0);
                            sum_awb_transit_disc += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_transit = parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_transit_disc = parseFloat(awb?.wgt || 0);
                          }
                          if (awb?.type === 'BUP') {
                            sum_awb_bup += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_bup = parseFloat(awb?.wgt || 0);
                          } else if (awb?.type === 'COMAT') {
                            sum_awb_comat += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_comat = parseFloat(awb?.wgt || 0);
                          }
                          if (awb) {
                            awb_count += found ? 0 : 1;
                            awb_count_disc += found ? 0 : 1;
                            awb_data.awb_count = found ? 1 : 0;
                            awb_data.awb_count_disc = found ? 1 : 0;
                            sum_manifested += parseFloat(awb?.wgt || 0);
                            awb_data.sum_manifested = parseFloat(awb?.wgt || 0);
                          }
                          sum_prodvals.map((rec) => {
                            if (awb?.product?.id === rec.id) {
                              rec.sum += 1;
                              awb_data[rec.key] = 1;
                            } else {
                              awb_data[rec.key] = 0;
                            }
                          });
                          sum_prodvals_disc.map((rec) => {
                            if (awb?.product?.id === rec.id) {
                              rec.sum += 1;
                              awb_data[rec.key] = 1;
                            } else {
                              awb_data[rec.key] = 0;
                            }
                          });
                          awbs.push(awb_data);
                          ob_awbs.push({ awb_no: awb?.awb_no });
                        });
                      }
                    });
                  }

                  if (flight_discrepancies.length > 0) {
                    flight_discrepancies.map((rec) => {
                      let found = false;
                      if (distinct_awbs.includes(rec?.awb_no)) {
                        found = true;
                      } else {
                        distinct_awbs.push(rec?.awb_no);
                      }
                      if (rec?.type === 'Missing Cargo' || rec?.type === 'Short Shipped') {
                        let awb_data = {
                          id: rec?.id,
                          awb_no: rec?.awb_no,
                          label: `${rec?.awb_no} - ${rec?.type}`,
                          flight_count: '-',
                          sum_awb_local_disc: 0,
                          sum_awb_export_disc: 0,
                          sum_awb_transit_disc: 0,
                          sum_manifested: 0,
                          prod_code: rec?.prod_code,
                          products: rec?.products || [],
                        };
                        sum_prodvals_disc.map((rec1) => {
                          // Check if awb.products contains a product with matching id
                          const hasProduct = Array.isArray(awb_data?.products) && awb_data.products.some(product => product.id === rec1.id);
                          if (hasProduct) {
                            rec1.sum += 1;
                            awb_data[rec1.key] = 1;
                          } else {
                            awb_data[rec1.key] = 0;
                          }
                        });
                        if (rec?.dest === this.station_code) {
                          awb_data.awb_count_disc += found ? 1 : 0;
                          awb_count_disc += found ? 1 : 0;
                          awb_data.sum_awb_local_disc -= parseFloat(rec?.d_wgt);
                          sum_awb_local_disc -= parseFloat(rec?.d_wgt);
                        } else if (rec?.org === this.station_code) {
                          awb_data.awb_count_disc += found ? 1 : 0;
                          awb_count_disc += found ? 1 : 0;
                          awb_data.sum_awb_export_disc -= parseFloat(rec?.d_wgt);
                          sum_awb_export_disc -= parseFloat(rec?.d_wgt);
                        } else if (rec?.org && rec?.dest) {
                          awb_data.awb_count_disc += found ? 1 : 0;
                          awb_count_disc += found ? 1 : 0;
                          awb_data.sum_awb_transit_disc -= parseFloat(rec?.d_wgt);
                          sum_awb_transit_disc -= parseFloat(rec?.d_wgt);
                        }
                        awbs.push(awb_data);
                        ob_awbs.push({ awb_no: rec?.awb_no });
                      } else if (rec?.type === 'Found Cargo' || rec?.type === 'Over Carried') {
                        let awb_data = {
                          id: rec?.id,
                          awb_no: rec?.awb_no,
                          label: `${rec?.awb_no} - ${rec?.type}`,
                          flight_count: '-',
                          awb_count_disc: 0,
                          sum_awb_local_disc: 0,
                          sum_awb_export_disc: 0,
                          sum_awb_transit_disc: 0,
                          sum_manifested: 0,
                          prod_code: rec?.prod_code,
                          products: rec?.products || [],
                        };
                        sum_prodvals_disc.map((rec1) => {
                          // Check if the product exists in the AWB data
                          const hasProduct = Array.isArray(awb_data?.products) && awb_data.products.some(product => product.id === rec1.id);
                          if (hasProduct) {
                            rec1.sum += 1;
                            awb_data[rec1.key] = 1;
                          } else {
                            awb_data[rec1.key] = 0;
                          }
                        });
                        if (rec?.dest === this.station_code) {
                          awb_data.awb_count_disc += found ? 1 : 0;
                          awb_count_disc += found ? 1 : 0;
                          awb_data.sum_awb_local_disc += parseFloat(rec?.d_wgt);
                          sum_awb_local_disc += parseFloat(rec?.d_wgt);
                        } else if (rec?.org === this.station_code) {
                          awb_data.awb_count_disc += found ? 1 : 0;
                          awb_count_disc += found ? 1 : 0;
                          awb_data.sum_awb_export_disc += parseFloat(rec?.d_wgt);
                          sum_awb_export_disc += parseFloat(rec?.d_wgt);
                        } else if (rec?.org && rec?.dest) {
                          awb_data.awb_count_disc += found ? 1 : 0;
                          awb_count_disc += found ? 1 : 0;
                          awb_data.sum_awb_transit_disc += parseFloat(rec?.d_wgt);
                          sum_awb_transit_disc += parseFloat(rec?.d_wgt);
                        }
                        awbs.push(awb_data);
                        ob_awbs.push({ awb_no: rec?.awb_no });
                      }
                    });
                  }

                  let flight = {
                    id: outflight?.id,
                    label: `${airline?.code}${outflight?.flight_no}/${moment(outflight?.flight_date, 'YYYY-MM-DD').format('DDMMMYY')}`,
                    act_arr: outflight?.act_arr,
                    act_dept: outflight?.act_dept,
                    schdl_arr: outflight?.schdl_arr,
                    schdl_dept: outflight?.schdl_dept,
                    start_dt: outflight?.start_dt,
                    end_dt: outflight?.end_dt,
                    type: outflight?.type,
                    org: outflight?.org,
                    dest: outflight?.dest,
                    url: `/flight_folder/notes?id=${outflight.id}`,
                    flight_schedule_id: outflight?.flight_schedule_id,
                    contractData: awbs,
                    flight_no: outflight?.flight_no,
                    flight_count: 1,
                    awb_count: awb_count,
                    awb_count_disc: awb_count_disc,
                    sum_awb_local: sum_awb_local,
                    sum_awb_local_disc: sum_awb_local_disc,
                    sum_awb_export: sum_awb_export,
                    sum_awb_export_disc: sum_awb_export_disc,
                    sum_awb_transit: sum_awb_transit,
                    sum_awb_transit_disc: sum_awb_transit_disc,
                    sum_awb_bup: sum_awb_bup,
                    sum_awb_comat: sum_awb_comat,
                    sum_manifested: sum_manifested,
                    subRows: awbs,
                    reports: outflight?.reports || [],
                  };
                  sum_prodvals.map((rec) => {
                    flight[rec.key] = rec.sum;
                  });
                  sum_prodvals_disc.map((rec) => {
                    flight[rec.key] = rec.sum;
                  });

                  ob_awb_count += awb_count;
                  ob_awb_count_disc += awb_count_disc;
                  ob_sum_awb_local += sum_awb_local;
                  ob_sum_awb_local_disc += sum_awb_local_disc;
                  ob_sum_awb_export += sum_awb_export;
                  ob_sum_awb_export_disc += sum_awb_export_disc;
                  ob_sum_awb_transit += sum_awb_transit;
                  ob_sum_awb_transit_disc += sum_awb_transit_disc;
                  ob_sum_awb_bup += sum_awb_bup;
                  ob_sum_awb_comat += sum_awb_comat;
                  ob_sum_manifested += sum_manifested;
                  ob_prodvals.map((rec) => {
                    rec.sum += flight[rec.key];
                  });
                  ob_prodvals_disc.map((rec) => {
                    rec.sum += flight[rec.key];
                  });
                  outbound_data.push(flight);

                });
              }
              let outboundgroupedDataArr = outbound_data.reduce((acc, obj) => {
                let key = `${airline?.code}${obj.flight_no}`;
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});
              let outboundParent = [];  // Flight Num grouping
              if (Object.keys(outboundgroupedDataArr).length > 0) {
                Object.entries(outboundgroupedDataArr).map(([key, rec]) => {
                  let outboundParentObj = {
                    label: key,
                    flight_count: 0,
                    awb_count: 0,
                    awb_count_disc: 0,
                    sum_awb_local: 0,
                    sum_awb_local_disc: 0,
                    sum_awb_export: 0,
                    sum_awb_export_disc: 0,
                    sum_awb_transit: 0,
                    sum_awb_transit_disc: 0,
                    sum_awb_bup: 0,
                    sum_awb_comat: 0,
                    sum_manifested: 0,
                    subRows: rec,
                  };
                  if (rec && rec.length > 0) {
                    rec.map((rec) => {
                      outboundParentObj.flight_count += rec.flight_count;
                      outboundParentObj.awb_count += rec.awb_count;
                      outboundParentObj.awb_count_disc += rec.awb_count_disc;
                      outboundParentObj.sum_awb_local += rec.sum_awb_local;
                      outboundParentObj.sum_awb_local_disc += rec.sum_awb_local_disc;
                      outboundParentObj.sum_awb_export += rec.sum_awb_export;
                      outboundParentObj.sum_awb_export_disc += rec.sum_awb_export_disc;
                      outboundParentObj.sum_awb_transit += rec.sum_awb_transit;
                      outboundParentObj.sum_awb_transit_disc += rec.sum_awb_transit_disc;
                      outboundParentObj.sum_awb_bup += rec.sum_awb_bup;
                      outboundParentObj.sum_awb_comat += rec.sum_awb_comat;
                      outboundParentObj.sum_manifested += rec.sum_manifested;
                    });
                  }
                  outboundParent.push(outboundParentObj);
                });
              }
              outbound = {
                id: `${airline?.id}_outbound`,
                label: `${ob_flight_count} Outbound Flights`,
                ex_label: 'Export',
                flight_count: ob_flight_count,
                flights: outbound_data,
                contractData: outbound_data?.map(obj => obj.subRows).flat(),
                awb_count: ob_awb_count,
                awb_count_disc: ob_awb_count_disc,
                sum_awb_local: ob_sum_awb_local,
                sum_awb_local_disc: ob_sum_awb_local_disc,
                sum_awb_export: ob_sum_awb_export,
                sum_awb_export_disc: ob_sum_awb_export_disc,
                sum_awb_transit: ob_sum_awb_transit,
                sum_awb_transit_disc: ob_sum_awb_transit_disc,
                sum_awb_bup: ob_sum_awb_bup,
                sum_awb_comat: ob_sum_awb_comat,
                sum_manifested: ob_sum_manifested,
                subRows: outboundParent,
                ob_awbs: ob_awbs,
              };
              ob_prodvals.map((rec) => {
                outbound[rec.key] = rec.sum;
              });
              ob_prodvals_disc.map((rec) => {
                outbound[rec.key] = rec.sum;
              });

              // let mainParent = [];  // Flight Num grouping
              let airline_data = {
                id: airline?.id,
                label: `${parseInt(ib_flight_count) + parseInt(ob_flight_count)} ${airline?.code} Flights`,
                ex_label: airline?.code,
                flight_count: ib_flight_count + ob_flight_count,
                inbound: inbound,
                outbound: outbound,
                contractData: [
                  ...inbound.contractData,
                  ...outbound.contractData
                ],
                awb_count: ib_awb_count + ob_awb_count,
                awb_count_disc: ib_awb_count_disc + ob_awb_count_disc,
                sum_awb_local: ib_sum_awb_local + ob_sum_awb_local,
                sum_awb_local_disc: ib_sum_awb_local_disc + ob_sum_awb_local_disc,
                sum_awb_export: ib_sum_awb_export + ob_sum_awb_export,
                sum_awb_export_disc: ib_sum_awb_export_disc + ob_sum_awb_export_disc,
                sum_awb_transit: ib_sum_awb_transit + ob_sum_awb_transit,
                sum_awb_transit_disc: ib_sum_awb_transit_disc + ob_sum_awb_transit_disc,
                sum_awb_bup: ib_sum_awb_bup + ob_sum_awb_bup,
                sum_awb_comat: ib_sum_awb_comat + ob_sum_awb_comat,
                sum_manifested: ib_sum_manifested + ob_sum_manifested,
                subRows: [inbound, outbound],
              };
              ib_prodvals.map((rec, index) => {
                airline_data[rec.key] = ib_prodvals[index].sum + ob_prodvals[index].sum;
              });
              ib_prodvals_disc.map((rec, index) => {
                airline_data[rec.key] = ib_prodvals_disc[index].sum + ob_prodvals_disc[index].sum;
              });
              billingData2.push(airline_data);
              // mainParent.push(airline_data);
              // mainParent.inbound = inboundParent;
              // mainParent.outbound = outboundParent;
              // this.setSummary(mainParent, 'airline');
            });
            // let summaryData = billingData2;
            this.setState({ billingData2: billingData2 }, () => {
              // this.filter();
              // this.setSummary(this.state.billingData2, 'airline');
              // this.setSummary(summaryData, 'airline');
              if (this.state.billingFields.transit === 'inbound' || this.state.billingFields.transit === 'outbound') {
                this.filterData();
                if (callback) return callback(true);
              } else {
                if (callback) {
                  this.filterData();
                  return callback(true);
                }
              }
            });
          } else {
            this.setState({ billingData2: [] });
            return callback(true);
          }
        });
    }
  };

  filterData = () => {
    const subtractValues = (obj, awb, fields) => {
      fields.forEach(field => {
        obj[field] = parseFloat(obj[field]) - (parseFloat(awb[field]) || 0);
      });
    };

    // const fields = ['sum_awb_local', 'sum_awb_local_disc', 'sum_awb_transit', 'sum_awb_transit_disc', 'sum_awb_bup', 'sum_awb_comat', 'sum_manifested'];
    const fields = [/*'sum_awb_local', 'sum_awb_local_disc',*/ 'sum_awb_transit', 'sum_awb_transit_disc', /*'sum_awb_bup', 'sum_awb_comat', 'sum_manifested'*/];
    let filteredData = cloneDeep(this.state.contractData);

    for (let airline of filteredData) {
      if (airline?.subRows?.length > 0) {
        let inbound = airline?.subRows.find((row) => row.label === 'Inbound');
        let outbound = airline?.subRows.find((row) => row.label === 'Outbound');
        let ib_awbs = inbound?.ib_awbs || [];
        let ob_awbs = outbound?.ob_awbs || [];

        switch (this.state.billingFields.transit) {
          case 'inbound':
            if (ib_awbs.length > 0) {
              for (let flightParent of outbound?.subRows || []) {
                for (let flight of flightParent?.subRows || []) {
                  let awbs = [];
                  for (let awb of flight?.subRows || []) {
                    let awb_index = ib_awbs.findIndex((rec) => rec.awb_no === awb.awb_no);
                    if (awb_index > -1) {
                      subtractValues(flight, awb, fields);
                      subtractValues(flightParent, awb, fields);
                      subtractValues(outbound, awb, fields);
                      subtractValues(airline, awb, fields);
                      awbs.push(awb);
                    } else {
                      awbs.push(awb);
                    }
                  }
                  flight.subRows = awbs;
                }
              }
            }
            break;
          case 'outbound':
            if (ob_awbs.length > 0) {
              for (let flightParent of inbound?.subRows || []) {
                for (let flight of flightParent?.subRows || []) {
                  let awbs = [];
                  for (let awb of flight?.subRows || []) {
                    let awb_index = ob_awbs.findIndex((rec) => rec.awb_no === awb.awb_no);
                    if (awb_index > -1) {
                      subtractValues(flight, awb, fields);
                      subtractValues(flightParent, awb, fields);
                      subtractValues(inbound, awb, fields);
                      subtractValues(airline, awb, fields);
                      awbs.push(awb);
                    } else {
                      awbs.push(awb);
                    }
                  }
                  flight.subRows = awbs;
                }
              }
            }
            break;
          default:
            break;
        }
        airline.subRows = [inbound, outbound];
      }
    }
    this.setState({ filteredData: filteredData });
  };

  generateBillingColumns = (type, callback) => {
    function formatNumber(num) {
      return num % 1 === 0 ? Math.round(num) : num.toFixed(2);
    }
    let prodkeys = [];
    let prodkeysDisc = [];
    let columns = [];
    if (this.state.billingFields.exclude_disc) {
      columns.push(
        {
          field: 'awb_count',
          headerName: 'AWBS',
          className: styles.rowLabels,
          width: 200,
          flex: 1,
          renderCell: (data) => {
            return (
              <div>
                {data.row.label}
              </div>
            );
          },
        },
        {
          field: 'sum_awb_local',
          headerName: 'AWBS local (KG)',
          width: 200,
          flex: 1,
          renderCell: ({ row }) => {
            let value = typeof row.sum_awb_local === 'number' ? formatNumber(Math.round(row.sum_awb_local * 100) / 100) : row.sum_awb_local;
            return value === 0 ? 'Nil' : value;
          },
        },
        {
          field: 'sum_awb_transit',
          headerName: 'AWBS transit (KG)',
          width: 200,
          flex: 1,
          renderCell: ({ row }) => {
            let value = typeof row.sum_awb_transit === 'number' ? formatNumber(Math.round(row.sum_awb_transit * 100) / 100) : row.sum_awb_transit;
            return value === 0 ? 'Nil' : value;
          },
        },
        {
          field: 'sum_awb_export',
          headerName: 'AWBS export (KG)',
          width: 200,
          flex: 1,
          renderCell: ({ row }) => {
            let value = typeof row.sum_awb_export === 'number' ? formatNumber(Math.round(row.sum_awb_export * 100) / 100) : row.sum_awb_export;
            return value === 0 ? 'Nil' : value;
          }
        },
      );
    } else {
      columns.push(
        {
          field: 'awb_count_disc',
          headerName: 'AWBS',
          className: styles.rowLabels,
          width: 200,
          flex: 1,
          renderCell: (data) => {
            return (
              <div>
                {data.row.label}
              </div>
            );
          },
        },
        {
          field: 'sum_awb_local_disc',
          headerName: 'AWBS local (KG)',
          width: 200,
          flex: 1,
          renderCell: ({ row }) => {
            let value = typeof row.sum_awb_local_disc === 'number' ? formatNumber(Math.round(row.sum_awb_local_disc * 100) / 100) : row.sum_awb_local_disc;
            value = value < 0 ? value * -1 : value;
            return value === 0 ? 'Nil' : value;
          },
        },
        {
          field: 'sum_awb_transit_disc',
          headerName: 'AWBS transit (KG)',
          width: 200,
          flex: 1,
          renderCell: ({ row }) => {
            let value = typeof row.sum_awb_transit_disc === 'number' ? formatNumber(Math.round(row.sum_awb_transit_disc * 100) / 100) : row.sum_awb_transit_disc;
            value = value < 0 ? value * -1 : value;
            return value === 0 ? 'Nil' : value;
          },
        },
        {
          field: 'sum_awb_export_disc',
          headerName: 'AWBS export (KG)',
          width: 200,
          flex: 1,
          renderCell: ({ row }) => {
            let value = typeof row.sum_awb_export_disc === 'number' ? formatNumber(Math.round(row.sum_awb_export_disc * 100) / 100) : row.sum_awb_export_disc;
            value = value < 0 ? value * -1 : value;
            return value === 0 ? 'Nil' : value;
          }
        },
      );
    }
    columns.push(
      {
        field: 'sum_manifested',
        headerName: 'TOTAL CARGO manifested (KG)',
        width: 200,
        flex: 1,
        renderCell: ({ row }) => {
          let value = typeof row.sum_manifested === 'number' ? formatNumber(Math.round(row.sum_manifested * 100) / 100) : row.sum_manifested;
          value = value < 0 ? value * -1 : value;
          return value === 0 ? 'Nil' : value;
        },
      },
    );
    if (this.state.products && this.state.products.length > 0) {
      columns.push(
        {
          field: 'product',
          headerName: 'Product',
          width: 200,
          flex: 1,
          // renderCell: ({ row }) => {
          //   let a = this.state.products.map((product) => {
          //     let prod = row[`sum_${product.name.trim()?.toLowerCase()}`];
          //     return prod && prod !== 0 ? `${product.name} (${prod})` : row.prod_code;
          //   });
          //   let prod_code = a && a.filter((item, index, inputArray) => {
          //     return inputArray.indexOf(item) == index;
          //   });
          //   let hasNullElements = a && a.every((item) => item == null || item == undefined);
          //   return hasNullElements ? '-' : prod_code;
          // },
          renderCell: ({ row }) => {
            // Only include products with a non-zero count
            let productList = this.state.products
              .map(product => {
                let count = row[`sum_${product.name.trim()?.toLowerCase()}`];
                return count && count !== 0 ? `${product.name} (${count})` : null;
              })
              .filter(Boolean); // Remove nulls

            return productList.length > 0 ? productList.join(', ') : '-';
          },
        },
      );
      this.state.products.map((product) => {
        if (this.state.billingFields.exclude_disc) {
          columns.push({
            field: `sum_${product.name?.trim()?.toLowerCase()}`,
            headerName: `# of ${product.name}`,
            width: 200,
            flex: 1,
          });
        }
        else {
          columns.push({
            field: `sum_${product.name?.trim()?.toLowerCase()}_disc`,
            headerName: `# of ${product.name}`,
            width: 200,
            flex: 1,
          });
        }
        prodkeys.push(
          {
            key: `sum_${product.name?.trim()?.toLowerCase()}`,
            id: product.id
          }
        );
        prodkeysDisc.push(
          {
            key: `sum_${product.name?.trim()?.toLowerCase()}_disc`,
            id: product.id
          }
        );
      });
    }
    //array without products
    let cloneColumn = cloneDeep(columns);
    let columLength = cloneColumn.length;
    let prodLength = this.state?.products?.length || 0;
    let total = columLength - prodLength;
    cloneColumn.splice(total, prodLength);

    //array without products column
    let billingColumns = cloneDeep(columns);
    let productIndex = billingColumns.findIndex((item) => item.field === 'product');
    if (productIndex !== -1) {
      billingColumns.splice(productIndex, 1);
    }

    this.setState({
      billingCol: cloneColumn,
      billingColumns: billingColumns,
      prodkeys: prodkeys,
      prodkeysDisc: prodkeysDisc,
    }, () => {
      if (type === 'fetch') {
        this.fetchBillingReport(() => {
          if (callback) return callback(true);
        }
        );
      }
    });
  };

  
  triggerNewBilling = (regenerate = false,) => {
    let from = moment(this.state.searchFields.from).format('YYYY-MM-DD');
    let to = moment(this.state.searchFields.to).format('YYYY-MM-DD');
    if (this.state.searchFields.month) {
      if (this.state.searchFields.period === 'month') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      } else if (this.state.searchFields.period === 'first') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(14, 'days').format('YYYY-MM-DD');
      } else {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(15, 'days').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      }
    }
    if (this.state.searchFields.airline) {
      http.get(`/populate_billing_queues?from=${from}&to=${to}&station=${this.station_code}&airline=${this.state.searchFields.airline}&type=${this.state.cont_item}&regenerate=${regenerate}`)  
        .then(({ data }) => {
          console.log('data', data);
          if(data?.data.length > 2){
            toast.success(data?.message);
          } else {
            toast.warning(data?.message);
          }
        });
    }
  };

  fetchInvoiceData = (regenerate = false) => {
    this.setState({ genInvProgress: true });
    console.log('fetchInvoiceData start', new Date().getHours(), new Date().getMinutes(), new Date().getSeconds(), new Date().getMilliseconds());
    let from = moment(this.state.searchFields.from).format('YYYY-MM-DD');
    let to = moment(this.state.searchFields.to).format('YYYY-MM-DD');
    if (this.state.searchFields.month) {
      if (this.state.searchFields.period === 'month') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      } else if (this.state.searchFields.period === 'first') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(14, 'days').format('YYYY-MM-DD');
      } else {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(15, 'days').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      }
    }
    if (this.state.searchFields.airline) {
      http.get(`/generate_invoice?from=${from}&to=${to}&station=${this.station_code}&airline=${this.state.searchFields.airline}&type=${this.state.cont_item}&regenerate=${regenerate}`)
        .then(({ data }) => {
          let flightdata = [];
          let invoicedata = data.data;
          let billingData = [];
          let alcontractsData = [];
          let invoice_info = data.data.invoice_infos[0] || null;
          //getinboundContractData
          let inbound_contractData = [];
          data.data.inflightcontracts.map((item,i) => {
            data.data.inflightcontracts[i].contractData= data.data.inflightcontracts[i].contractData.map((item, index) => ({
              ...cloneDeep(item),
              id: `${index + 1}_inflight`,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
            }));
            item.contractData.map((rec) => {
              let index = inbound_contractData.findIndex((obj) => obj.contractId === rec.contractId && obj.cont_rowId === rec.cont_rowId);
              if (index === -1) {
                inbound_contractData.push(rec);
              } 
              // else {
              //   inbound_contractData[index].quantity = parseFloat(inbound_contractData[index].quantity) + parseFloat(rec.quantity);
              //   inbound_contractData[index].totalrate = parseFloat(inbound_contractData[index].totalrate) + parseFloat(rec.totalrate);
              // }
            });
          });
          let outbound_contractData = [];
          data.data.outflightcontracts.map((item,i) => {
            data.data.outflightcontracts[i].contractData= data.data.outflightcontracts[i].contractData.map((item, index) => ({
              ...cloneDeep(item),
              id: `${index + 1}_outflight`,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
            }));
            item.contractData.map((rec) => {
              let index = outbound_contractData.findIndex((obj) => obj.contractId === rec.contractId && obj.cont_rowId === rec.cont_rowId);
              if (index === -1) {
                outbound_contractData.push(rec);
              } 
              // else {
              //   outbound_contractData[index].quantity = parseFloat(outbound_contractData[index].quantity) + parseFloat(rec.quantity);
              //   outbound_contractData[index].totalrate = parseFloat(outbound_contractData[index].totalrate) + parseFloat(rec.totalrate);
              // }
            });
          });
          flightdata = data.data.inflightcontracts.concat(data.data.outflightcontracts);

          let day_contractData = [];
          let dayStastics = {
            total_count: 0,
            finalized_count: 0,
            pending_count: 0,
            rejected_count: 0,
            approved_acc_count: 0,
            approved_air_count: 0
          };
          data.data.daycontracts.map((item,i) => {
            data.data.daycontracts[i].contractData= data.data.daycontracts[i].contractData.map((item, index) => ({
              ...cloneDeep(item),
              id: `${index + 1}_daylog`,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
            }));

            item.contractData.map((rec) => {
              let index = day_contractData.findIndex((obj) => obj.contractId === rec.contractId && obj.cont_rowId === rec.cont_rowId);
              if (index === -1) {
                day_contractData.push(cloneDeep(rec));
              } 
              else {
                day_contractData[index].quantity = rec.quantity ? parseFloat(day_contractData[index].quantity) + parseFloat(rec.quantity) : parseFloat(day_contractData[index].quantity);
                day_contractData[index].totalrate = rec.totalrate ? parseFloat(day_contractData[index].totalrate) + parseFloat(rec.totalrate) : parseFloat(day_contractData[index].totalrate);
              }
            });
            dayStastics.total_count += 1;
            if (item.status === 'Finalized' || item.status === 'Pending' || item.status === 'Approved') {
              dayStastics.finalized_count += 1;
            } 
            if (item.status === '' || item.status === null || item.status === 'Not Finalized') {
              dayStastics.pending_count += 1;
            } 
            if (item.status === 'Rejected') {
              dayStastics.rejected_count += 1;
            } 
            if ((item.status === 'Pending' && item.approved_acc === true) || (item.status === 'Approved' && item.approved_acc === true)) {
              dayStastics.approved_acc_count += 1;
            }
            if (item.status === 'Approved' && item.approved_air === true) {
              dayStastics.approved_air_count += 1;
            }
          });
          let month_contractData = [];
          let monthStastics = {
            total_count: 0,
            finalized_count: 0,
            pending_count: 0,
            rejected_count: 0,
            approved_acc_count: 0,
            approved_air_count: 0
          };
          data.data.monthcontracts.map((item,i) => {
            data.data.monthcontracts[i].contractData= data.data.monthcontracts[i].contractData.map((item, index) => ({
              ...cloneDeep(item),
              id: `${index + 1}_monthlog`,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
            }));

            item.contractData.map((rec) => {
              let index = month_contractData.findIndex((obj) => obj.contractId === rec.contractId && obj.cont_rowId === rec.cont_rowId);
              if (index === -1) {
                month_contractData.push(cloneDeep(rec));
              } 
              // else {
              //   month_contractData[index].quantity = parseFloat(month_contractData[index].quantity) + parseFloat(rec.quantity);
              //   month_contractData[index].totalrate = parseFloat(month_contractData[index].totalrate) + parseFloat(rec.totalrate);
              // }
            });
            monthStastics.total_count += 1;
            if (item.status === 'Finalized' || item.status === 'Pending' || item.status === 'Approved') {
              monthStastics.finalized_count += 1;
            }
            if (item.status === '' || item.status === null || item.status === 'Not Finalized') {
              monthStastics.pending_count += 1;
            }
            if (item.status === 'Rejected') {
              monthStastics.rejected_count += 1;
            }
            if ((item.status === 'Pending' && item.approved_acc === true) || (item.status === 'Approved' && item.approved_acc === true)) {
              monthStastics.approved_acc_count += 1;
            }
            if (item.status === 'Approved' && item.approved_air === true) {
              monthStastics.approved_air_count += 1;
            }
          });

          let inbound = {
            id: 'inbound',
            label: `${data.data.inflightcontracts.length} Inbound Flights`,
            flight_count: data.data.inflightcontracts.length,
            flights: data.data.inflightcontracts,
            contractData: inbound_contractData.map((item, index) => ({ 
              ...item, 
              id: `${index + 1}_daylog`,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
            })), // Need to add ids
          };
          let outbound = {
            id: 'outbound',
            label: `${data.data.outflightcontracts.length} Outbound Flights`,
            flight_count: data.data.outflightcontracts.length,
            flights: data.data.outflightcontracts,
            contractData: outbound_contractData.map((item, index) => ({ 
              ...item, 
              id: `${index + 1}_daylog`,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
            })), // Need to Sum up all outbound data
          };
          
          let daylog = {
            id: 'daylog',
            label: `${data.data.daycontracts.length} Daily Logs`,
            daylog_count: data.data.daycontracts.length, // Need to replace this with alldaylogs count
            daylogs: data.data.daycontracts,
            alldaylogs: data.data.daycontracts, // need to change this
            contractData: day_contractData.map((item, index) => ({ 
              ...item, 
              id: `${index + 1}_daylog`,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
            })), // Need to Sum up all daylogs data
            dayStastics: dayStastics,
          };
          let monthlog = {
            id: 'monthlog',
            label: `${data.data.monthcontracts.length} Monthly Log`,
            // monthlog_count: 1,
            monthlog_count: data.data.monthcontracts.length,
            monthlogs: data.data.monthcontracts,
            contractData: month_contractData.map((item, index) => ({ 
              ...item, 
              id: `${index + 1}_monthlog`,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
            })), // Need to Sum up all monthlogs data
            monthStastics: monthStastics
          };
          console.log('dayStastics', dayStastics);
          console.log('monthStastics', monthStastics);
          let customReportOptions = [];
          if(data.data?.airlinecontracts.length > 0 && data.data?.airlinecontracts[0]?.contractData){
            data.data?.airlinecontracts[0]?.contractData.map((item) => {
              console.log('pushing item to customReportOption 1');
              customReportOptions.push({
                title: item.label,
                value: item.id,
              });
            });
          }
          if(data.data?.airlinecontracts[0]?.noncommercialData){
            data.data?.airlinecontracts[0]?.noncommercialData.map((item) => {
              console.log('pushing item to customReportOption 2');
              customReportOptions.push({
                title: item.description,
                value: item.id,
              });
            });
          }
          let airline_data = {
            id: data.data?.airlinecontracts[0]?.label,
            label: `${parseInt(data.data.inflightcontracts.length) + parseInt(data.data.outflightcontracts.length)}  ${data.data?.airlinecontracts[0]?.label || (this.state.airlineCode + ' Flights')}`,
            sllabel: `${parseInt(monthlog?.monthlog_count) + parseInt(daylog?.daylog_count)} ${data.data?.airlinecontracts[0]?.slabel || (this.state.airlineCode + ' Service Logs')}`,
            flight_count: parseInt(data.data.inflightcontracts.length) + parseInt(data.data.outflightcontracts.length),
            inbound: inbound,
            outbound: outbound,
            alcontractsData: data.data.airlinecontracts[0]?.contractData.map((item, index) => ({
              ...item, 
              id: `${index + 1}_daylog`,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
            })) || [],
            contractData: [...monthlog.contractData, ...daylog.contractData],
            daylog: daylog,
            monthlog: monthlog,
          };        
          billingData.push(airline_data);
          let contractData = [];
          let dayContractData = [];
          let monthContractData = [];
          let accord_id = null;
          let accord_type = null;
          let daylogdata = [];
          let monthlogdata = [];
          if (billingData.length > 0) {
            alcontractsData = billingData[0]?.alcontractsData;
            contractData = billingData[0]?.contractData;
            accord_id = billingData[0]?.id;
            accord_type = 'airline';
            dayContractData = billingData[0]?.daylog?.contractData;
            monthContractData = billingData[0]?.monthlog?.contractData;
            daylogdata = billingData[0]?.daylog?.alldaylogs;
            monthlogdata = billingData[0]?.monthlog?.allmonthlogs;
          }
          // console.log('billingData', billingData);
          // console.log('flightdata', flightdata);
          // console.log('invoicedata', invoicedata);
          // console.log('daylogdata*************', daylogdata);
          // console.log('monthlogdata***********', monthlogdata);
          // console.log('contractData', contractData);
          // console.log('dayContractData', dayContractData);
          // console.log('monthContractData', monthContractData);
          this.setState({
            flightdata: flightdata || [],
            invoicedata: invoicedata || [],
            billingData: billingData || [],
            daylogdata: daylogdata || [],
            monthlogdata: monthlogdata || [],
            alcontractsData: alcontractsData,
            contractData: contractData || [],
            dayContractData: dayContractData || [],
            monthContractData: monthContractData || [],
            invoice_info: invoice_info || null,
            accord_id: accord_id,
            accord_type: accord_type,
            genInvProgress: false,
            customReportOptions: customReportOptions || [],
          }, () => {
            console.log('fetchInvoiceData end', new Date().getHours(), new Date().getMinutes(), new Date().getSeconds(), new Date().getMilliseconds());
            // if (this.state.billingFields.transit === 'inbound' || this.state.billingFields.transit === 'outbound') {
            //   this.filterData();
            // }
          });
        });
    } else {
      this.setState({ genInvProgress: false });
    }
  };

  fetchInvoiceData2 = (regenerate = false, callType = null, callback = false) => {
    if(callType){
      // Ignore, nothing to do
    }
    let from = moment(this.state.searchFields.from).format('YYYY-MM-DD');
    let to = moment(this.state.searchFields.to).format('YYYY-MM-DD');
    if (this.state.searchFields.month) {
      if (this.state.searchFields.period === 'month') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      } else if (this.state.searchFields.period === 'first') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(14, 'days').format('YYYY-MM-DD');
      } else {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(15, 'days').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      }
    }
    let dateType = 'scheduled';
    if(this.state.billingFields.dateType === 'actual'){
      dateType = 'actual';
    }
    if (this.state.searchFields.airline) {
      http.get(`/generate_invoice?from=${from}&to=${to}&station=${this.station_code}&airline=${this.state.searchFields.airline}&type=${this.state.cont_item}&regenerate=${regenerate}&datetype=${dateType}`)
        .then(({ data }) => {
          // sort airlinecontracts, daycontracts, inflightcontracts, monthcontracts, outflightcontracts by position
          if(data.data.airlinecontracts[0]?.contractData)
            data.data.airlinecontracts[0].contractData = data.data.airlinecontracts?.[0]?.contractData.sort((a, b) => a.position - b.position);
          if(data.data.daycontracts[0]?.contractData)
            data.data.daycontracts[0].contractData = data.data.daycontracts?.[0]?.contractData.sort((a, b) => a.position - b.position);
          if(data.data.inflightcontracts[0]?.contractData)
            data.data.inflightcontracts[0].contractData = data.data.inflightcontracts?.[0]?.contractData.sort((a, b) => a.position - b.position);
          if(data.data.monthcontracts[0]?.contractData)
            data.data.monthcontracts[0].contractData = data.data.monthcontracts?.[0]?.contractData.sort((a, b) => a.position - b.position);
          if(data.data.outflightcontracts[0]?.contractData)
            data.data.outflightcontracts[0].contractData = data.data.outflightcontracts?.[0]?.contractData.sort((a, b) => a.position - b.position);
          let customReportOptions = [];
          if(data.data?.airlinecontracts.length > 0 && data.data?.airlinecontracts[0]?.contractData){
            data.data?.airlinecontracts[0]?.contractData.map((item) => {
              customReportOptions.push({
                title: item.label,
                value: item.id,
              });
            });
            // customReportOptions = data.data?.airlinecontracts[0]?.contractData;
            //also add noncommercialData
          }
          if(data.data?.airlinecontracts[0]?.noncommercialData){
            data.data?.airlinecontracts[0]?.noncommercialData.map((item) => {
              customReportOptions.push({
                title: item.description,
                value: item.id,
              });
            });
            // customReportOptions = customReportOptions.concat(data.data?.airlinecontracts[0]?.noncommercialData);
          }
          // generate_invoice
          // let flightdata = [];
          // let invoicedata = data.data;
          let billingData = [];
          let csvContracts = [];
          if(data.data?.airlinecontracts.length > 0 && data.data?.airlinecontracts[0]?.noncommercialData.length > 0){
            csvContracts = data.data?.airlinecontracts[0]?.noncommercialData;
          }
          // let alcontractsData = [];
          // let invoice_info = data.data.invoice_infos[0] || null;
          //getinboundContractData
          let inbound_contractData = [];
          let inboundStatistics = {
            total_count: 0,
            finalized_count: 0,
            pending_count: 0,
            rejected_count: 0,
            approved_acc_count: 0,
            approved_air_count: 0
          };
          data.data.inflightcontracts.map((item, i) => {
            data.data.inflightcontracts[i].contractData = data.data.inflightcontracts[i].contractData.map((item, index) => ({
              ...cloneDeep(item),
              id: `${index + 1}_inflight`,
              row_id: item.id,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
            }));
            item.contractData.map((rec) => {
              let ind = inbound_contractData.findIndex((obj) => obj.contractId === rec.contractId && obj.cont_rowId === rec.cont_rowId);
              if (ind === -1) {
                inbound_contractData.push(cloneDeep(rec));
              }
              else {
                inbound_contractData[ind].quantity = (!isNaN(inbound_contractData[ind].quantity) ? parseFloat(inbound_contractData[ind].quantity) : 0) + parseFloat(rec.quantity) || 0;
                inbound_contractData[ind].totalrate = (!isNaN(inbound_contractData[ind].totalrate) ? parseFloat(inbound_contractData[ind].totalrate) : 0) + parseFloat(rec.totalrate) || 0;
                inbound_contractData[ind].dis_quantity = (!isNaN(inbound_contractData[ind].dis_quantity) ? parseFloat(inbound_contractData[ind].dis_quantity) : 0) + parseFloat(rec.dis_quantity) || 0;
                inbound_contractData[ind].dis_totalrate = (!isNaN(inbound_contractData[ind].dis_totalrate) ? parseFloat(inbound_contractData[ind].dis_totalrate) : 0) + parseFloat(rec.dis_totalrate) || 0;
                inbound_contractData[ind].in_quantity = (!isNaN(inbound_contractData[ind].in_quantity) ? parseFloat(inbound_contractData[ind].in_quantity) : 0) + parseFloat(rec.in_quantity) || 0;
                inbound_contractData[ind].in_totalrate = (!isNaN(inbound_contractData[ind].in_totalrate) ? parseFloat(inbound_contractData[ind].in_totalrate) : 0) + parseFloat(rec.in_totalrate) || 0;
                inbound_contractData[ind].out_quantity = (!isNaN(inbound_contractData[ind].out_quantity) ? parseFloat(inbound_contractData[ind].out_quantity) : 0) + parseFloat(rec.out_quantity) || 0;
                inbound_contractData[ind].out_totalrate = (!isNaN(inbound_contractData[ind].out_totalrate) ? parseFloat(inbound_contractData[ind].out_totalrate) : 0) + parseFloat(rec.out_totalrate) || 0;
                inbound_contractData[ind].dis_in_quantity = (!isNaN(inbound_contractData[ind].dis_in_quantity) ? parseFloat(inbound_contractData[ind].dis_in_quantity) : 0) + parseFloat(rec.dis_in_quantity) || 0;
                inbound_contractData[ind].dis_in_totalrate = (!isNaN(inbound_contractData[ind].dis_in_totalrate) ? parseFloat(inbound_contractData[ind].dis_in_totalrate) : 0) + parseFloat(rec.dis_in_totalrate) || 0;
                inbound_contractData[ind].dis_out_quantity = (!isNaN(inbound_contractData[ind].dis_out_quantity) ? parseFloat(inbound_contractData[ind].dis_out_quantity) : 0) + parseFloat(rec.dis_out_quantity) || 0;
                inbound_contractData[ind].dis_out_totalrate = (!isNaN(inbound_contractData[ind].dis_out_totalrate) ? parseFloat(inbound_contractData[ind].dis_out_totalrate) : 0) + parseFloat(rec.dis_out_totalrate) || 0;
                
                inbound_contractData[ind].in_fquantity = (!isNaN(inbound_contractData[ind].in_fquantity) ? parseFloat(inbound_contractData[ind].in_fquantity) : 0) + parseFloat(rec.in_fquantity) || 0;
                inbound_contractData[ind].out_fquantity = (!isNaN(inbound_contractData[ind].out_fquantity) ? parseFloat(inbound_contractData[ind].out_fquantity) : 0) + parseFloat(rec.out_fquantity) || 0;
                inbound_contractData[ind].dis_in_fquantity = (!isNaN(inbound_contractData[ind].dis_in_fquantity) ? parseFloat(inbound_contractData[ind].dis_in_fquantity) : 0) + parseFloat(rec.dis_in_fquantity) || 0;
                inbound_contractData[ind].dis_out_fquantity = (!isNaN(inbound_contractData[ind].dis_out_fquantity) ? parseFloat(inbound_contractData[ind].dis_out_fquantity) : 0) + parseFloat(rec.dis_out_fquantity) || 0;
                inbound_contractData[ind].in_tquantity = (!isNaN(inbound_contractData[ind].in_tquantity) ? parseFloat(inbound_contractData[ind].in_tquantity) : 0) + parseFloat(rec.in_tquantity) || 0;
                inbound_contractData[ind].out_tquantity = (!isNaN(inbound_contractData[ind].out_tquantity) ? parseFloat(inbound_contractData[ind].out_tquantity) : 0) + parseFloat(rec.out_tquantity) || 0;
                inbound_contractData[ind].dis_in_tquantity = (!isNaN(inbound_contractData[ind].dis_in_tquantity) ? parseFloat(inbound_contractData[ind].dis_in_tquantity) : 0) + parseFloat(rec.dis_in_tquantity) || 0;
                inbound_contractData[ind].dis_out_tquantity = (!isNaN(inbound_contractData[ind].dis_out_tquantity) ? parseFloat(inbound_contractData[ind].dis_out_tquantity) : 0) + parseFloat(rec.dis_out_tquantity) || 0;

                // Initialize all quantities of inbound_contractData[ind].children to 0
                if (!inbound_contractData[ind].children || inbound_contractData[ind].children.length === 0) {
                  inbound_contractData[ind].children = rec.children ? rec.children.map(child => ({
                    ...child,
                    quantity: 0,
                    dis_quantity: 0,
                    in_quantity: 0,
                    out_quantity: 0,
                    dis_in_quantity: 0,
                    dis_out_quantity: 0,

                    in_fquantity: 0,
                    out_fquantity: 0,
                    dis_in_fquantity: 0,
                    dis_out_fquantity: 0,
                    in_tquantity: 0,
                    out_tquantity: 0,
                    dis_in_tquantity: 0,
                    dis_out_tquantity: 0,
                  })): [
                    {
                      quantity: 0,
                      dis_quantity: 0,
                      in_quantity: 0,
                      out_quantity: 0,
                      dis_in_quantity: 0,
                      dis_out_quantity: 0,

                      in_fquantity: 0,
                      out_fquantity: 0,
                      dis_in_fquantity: 0,
                      dis_out_fquantity: 0,
                      in_tquantity: 0,
                      out_tquantity: 0,
                      dis_in_tquantity: 0,
                      dis_out_tquantity: 0,
                    }
                  ];
                }
                // Sum quantities of children and assign to inbound_contractData[ind].children
                if (rec.children && rec.children.length > 0) {
                  rec.children.forEach((child, childIndex) => {
                    inbound_contractData[ind].children[childIndex].quantity += parseFloat(child.quantity) || 0;
                    inbound_contractData[ind].children[childIndex].dis_quantity += parseFloat(child.dis_quantity) || 0;
                    inbound_contractData[ind].children[childIndex].in_quantity += parseFloat(child.in_quantity) || 0;
                    inbound_contractData[ind].children[childIndex].out_quantity += parseFloat(child.out_quantity) || 0;
                    inbound_contractData[ind].children[childIndex].dis_in_quantity += parseFloat(child.dis_in_quantity) || 0;
                    inbound_contractData[ind].children[childIndex].dis_out_quantity += parseFloat(child.dis_out_quantity) || 0;

                    inbound_contractData[ind].children[childIndex].in_fquantity += parseFloat(child.in_fquantity) || 0;
                    inbound_contractData[ind].children[childIndex].out_fquantity += parseFloat(child.out_fquantity) || 0;
                    inbound_contractData[ind].children[childIndex].dis_in_fquantity += parseFloat(child.dis_in_fquantity) || 0;
                    inbound_contractData[ind].children[childIndex].dis_out_fquantity += parseFloat(child.dis_out_fquantity) || 0;
                    inbound_contractData[ind].children[childIndex].in_tquantity += parseFloat(child.in_tquantity) || 0;
                    inbound_contractData[ind].children[childIndex].out_tquantity += parseFloat(child.out_tquantity) || 0;
                    inbound_contractData[ind].children[childIndex].dis_in_tquantity += parseFloat(child.dis_in_tquantity) || 0;
                    inbound_contractData[ind].children[childIndex].dis_out_tquantity += parseFloat(child.dis_out_tquantity) || 0;
                  });
                }
              }
            });
            inboundStatistics.total_count += 1;
            if (item.status === 'Finalized' || item.status === 'Pending' || item.status === 'Approved') {
              inboundStatistics.finalized_count += 1;
            }
            if (item.status === '' || item.status === null || item.status === 'Not Finalized') {
              inboundStatistics.pending_count += 1;
            }
            if (item.status === 'Rejected') {
              inboundStatistics.rejected_count += 1;
            }
            if ((item.status === 'Pending' && item.approved_acc === true) || (item.status === 'Approved' && item.approved_acc === true)) {
              inboundStatistics.approved_acc_count += 1;
            } else if (item.status === 'Approved' && item.approved_air === true) {
              inboundStatistics.approved_air_count += 1;
            }
          });
          let outbound_contractData = [];
          let outboundStatistics = {
            total_count: 0,
            finalized_count: 0,
            pending_count: 0,
            rejected_count: 0,
            approved_acc_count: 0,
            approved_air_count: 0
          };
          data.data.outflightcontracts.map((item, i) => {
            data.data.outflightcontracts[i].contractData = data.data.outflightcontracts[i].contractData.map((item, index) => ({
              ...cloneDeep(item),
              id: `${index + 1}_outflight`,
              row_id: item.id,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
            }));
            item.contractData.map((rec) => {
              let ind = outbound_contractData.findIndex((obj) => obj.contractId === rec.contractId && obj.cont_rowId === rec.cont_rowId);
              if (ind === -1) {
                outbound_contractData.push(cloneDeep(rec));
              }
              else {
                outbound_contractData[ind].quantity = (!isNaN(outbound_contractData[ind].quantity) ? parseFloat(outbound_contractData[ind].quantity) : 0) + parseFloat(rec.quantity) || 0;
                outbound_contractData[ind].totalrate = (!isNaN(outbound_contractData[ind].totalrate) ? parseFloat(outbound_contractData[ind].totalrate) : 0) + parseFloat(rec.totalrate) || 0;
                outbound_contractData[ind].dis_quantity = (!isNaN(outbound_contractData[ind].dis_quantity) ? parseFloat(outbound_contractData[ind].dis_quantity) : 0) + parseFloat(rec.dis_quantity) || 0;
                outbound_contractData[ind].dis_totalrate = (!isNaN(outbound_contractData[ind].dis_totalrate) ? parseFloat(outbound_contractData[ind].dis_totalrate) : 0) + parseFloat(rec.dis_totalrate) || 0;
                outbound_contractData[ind].in_quantity = (!isNaN(outbound_contractData[ind].in_quantity) ? parseFloat(outbound_contractData[ind].in_quantity) : 0) + parseFloat(rec.in_quantity) || 0;
                outbound_contractData[ind].in_totalrate = (!isNaN(outbound_contractData[ind].in_totalrate) ? parseFloat(outbound_contractData[ind].in_totalrate) : 0) + parseFloat(rec.in_totalrate) || 0;
                outbound_contractData[ind].out_quantity = (!isNaN(outbound_contractData[ind].out_quantity) ? parseFloat(outbound_contractData[ind].out_quantity) : 0) + parseFloat(rec.out_quantity) || 0;
                outbound_contractData[ind].out_totalrate = (!isNaN(outbound_contractData[ind].out_totalrate) ? parseFloat(outbound_contractData[ind].out_totalrate) : 0) + parseFloat(rec.out_totalrate) || 0;
                outbound_contractData[ind].dis_in_quantity = (!isNaN(outbound_contractData[ind].dis_in_quantity) ? parseFloat(outbound_contractData[ind].dis_in_quantity) : 0) + parseFloat(rec.dis_in_quantity) || 0;
                outbound_contractData[ind].dis_in_totalrate = (!isNaN(outbound_contractData[ind].dis_in_totalrate) ? parseFloat(outbound_contractData[ind].dis_in_totalrate) : 0) + parseFloat(rec.dis_in_totalrate) || 0;
                outbound_contractData[ind].dis_out_quantity = (!isNaN(outbound_contractData[ind].dis_out_quantity) ? parseFloat(outbound_contractData[ind].dis_out_quantity) : 0) + parseFloat(rec.dis_out_quantity) || 0;
                outbound_contractData[ind].dis_out_totalrate = (!isNaN(outbound_contractData[ind].dis_out_totalrate) ? parseFloat(outbound_contractData[ind].dis_out_totalrate) : 0) + parseFloat(rec.dis_out_totalrate) || 0;

                outbound_contractData[ind].in_fquantity = (!isNaN(outbound_contractData[ind].in_fquantity) ? parseFloat(outbound_contractData[ind].in_fquantity) : 0) + parseFloat(rec.in_fquantity) || 0;
                outbound_contractData[ind].out_fquantity = (!isNaN(outbound_contractData[ind].out_fquantity) ? parseFloat(outbound_contractData[ind].out_fquantity) : 0) + parseFloat(rec.out_fquantity) || 0;
                outbound_contractData[ind].dis_in_fquantity = (!isNaN(outbound_contractData[ind].dis_in_fquantity) ? parseFloat(outbound_contractData[ind].dis_in_fquantity) : 0) + parseFloat(rec.dis_in_fquantity) || 0;
                outbound_contractData[ind].dis_out_fquantity = (!isNaN(outbound_contractData[ind].dis_out_fquantity) ? parseFloat(outbound_contractData[ind].dis_out_fquantity) : 0) + parseFloat(rec.dis_out_fquantity) || 0;
                outbound_contractData[ind].in_tquantity = (!isNaN(outbound_contractData[ind].in_tquantity) ? parseFloat(outbound_contractData[ind].in_tquantity) : 0) + parseFloat(rec.in_tquantity) || 0;
                outbound_contractData[ind].out_tquantity = (!isNaN(outbound_contractData[ind].out_tquantity) ? parseFloat(outbound_contractData[ind].out_tquantity) : 0) + parseFloat(rec.out_tquantity) || 0;
                outbound_contractData[ind].dis_in_tquantity = (!isNaN(outbound_contractData[ind].dis_in_tquantity) ? parseFloat(outbound_contractData[ind].dis_in_tquantity) : 0) + parseFloat(rec.dis_in_tquantity) || 0;
                outbound_contractData[ind].dis_out_tquantity = (!isNaN(outbound_contractData[ind].dis_out_tquantity) ? parseFloat(outbound_contractData[ind].dis_out_tquantity) : 0) + parseFloat(rec.dis_out_tquantity) || 0;

                // Initialize all quantities of outbound_contractData[ind].children to 0
                if (!outbound_contractData[ind].children || outbound_contractData[ind].children.length === 0) {
                  outbound_contractData[ind].children = rec.children ? rec.children.map(child => ({
                    ...child,
                    quantity: 0,
                    dis_quantity: 0,
                    in_quantity: 0,
                    out_quantity: 0,
                    dis_in_quantity: 0,
                    dis_out_quantity: 0,

                    in_fquantity: 0,
                    out_fquantity: 0,
                    dis_in_fquantity: 0,
                    dis_out_fquantity: 0,
                    in_tquantity: 0,
                    out_tquantity: 0,
                    dis_in_tquantity: 0,
                    dis_out_tquantity: 0,
                  })) : [
                    {
                      quantity: 0,
                      dis_quantity: 0,
                      in_quantity: 0,
                      out_quantity: 0,
                      dis_in_quantity: 0,
                      dis_out_quantity: 0,

                      in_fquantity: 0,
                      out_fquantity: 0,
                      dis_in_fquantity: 0,
                      dis_out_fquantity: 0,
                      in_tquantity: 0,
                      out_tquantity: 0,
                      dis_in_tquantity: 0,
                      dis_out_tquantity: 0,
                    }
                  ];
                }
                // Sum quantities of children and assign to outbound_contractData[ind].children
                if (rec.children && rec.children.length > 0) {
                  rec.children.forEach((child, childIndex) => {
                    outbound_contractData[ind].children[childIndex].quantity += parseFloat(child.quantity) || 0;
                    outbound_contractData[ind].children[childIndex].dis_quantity += parseFloat(child.dis_quantity) || 0;
                    outbound_contractData[ind].children[childIndex].in_quantity += parseFloat(child.in_quantity) || 0;
                    outbound_contractData[ind].children[childIndex].out_quantity += parseFloat(child.out_quantity) || 0;
                    outbound_contractData[ind].children[childIndex].dis_in_quantity += parseFloat(child.dis_in_quantity) || 0;
                    outbound_contractData[ind].children[childIndex].dis_out_quantity += parseFloat(child.dis_out_quantity) || 0;

                    outbound_contractData[ind].children[childIndex].in_fquantity += parseFloat(child.in_fquantity) || 0;
                    outbound_contractData[ind].children[childIndex].out_fquantity += parseFloat(child.out_fquantity) || 0;
                    outbound_contractData[ind].children[childIndex].dis_in_fquantity += parseFloat(child.dis_in_fquantity) || 0;
                    outbound_contractData[ind].children[childIndex].dis_out_fquantity += parseFloat(child.dis_out_fquantity) || 0;
                    outbound_contractData[ind].children[childIndex].in_tquantity += parseFloat(child.in_tquantity) || 0;
                    outbound_contractData[ind].children[childIndex].out_tquantity += parseFloat(child.out_tquantity) || 0;
                    outbound_contractData[ind].children[childIndex].dis_in_tquantity += parseFloat(child.dis_in_tquantity) || 0;
                    outbound_contractData[ind].children[childIndex].dis_out_tquantity += parseFloat(child.dis_out_tquantity) || 0;
                  });
                }
              }
            });
            outboundStatistics.total_count += 1;
            if (item.status === 'Finalized' || item.status === 'Pending' || item.status === 'Approved') {
              outboundStatistics.finalized_count += 1;
            }
            if (item.status === '' || item.status === null || item.status === 'Not Finalized') {
              outboundStatistics.pending_count += 1;
            }
            if (item.status === 'Rejected') {
              outboundStatistics.rejected_count += 1;
            }
            if ((item.status === 'Pending' && item.approved_acc === true) || (item.status === 'Approved' && item.approved_acc === true)) {
              outboundStatistics.approved_acc_count += 1;
            } else if (item.status === 'Approved' && item.approved_air === true) {
              outboundStatistics.approved_air_count += 1;
            }
          });
          // flightdata = data.data.inflightcontracts.concat(data.data.outflightcontracts);

          let day_contractData = [];
          data.data.daycontracts.map((item, i) => {
            data.data.daycontracts[i].contractData = data.data.daycontracts[i].contractData.map((item, index) => ({
              ...cloneDeep(item),
              id: `${index + 1}_daylog`,
              row_id: item.id,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
            }));

            item.contractData.map((rec) => {
              let index = day_contractData.findIndex((obj) => obj.contractId === rec.contractId && obj.cont_rowId === rec.cont_rowId);
              if (index === -1) {
                day_contractData.push(cloneDeep(rec));
              }
              else {
                day_contractData[index].quantity = rec.quantity ? parseFloat(day_contractData[index].quantity) + parseFloat(rec.quantity) : parseFloat(day_contractData[index].quantity);
                day_contractData[index].totalrate = rec.totalrate ? parseFloat(day_contractData[index].totalrate) + parseFloat(rec.totalrate) : parseFloat(day_contractData[index].totalrate);
              }
            });
          });
          let month_contractData = [];
          data.data.monthcontracts.map((item, i) => {
            data.data.monthcontracts[i].contractData = data.data.monthcontracts[i].contractData.map((item, index) => ({
              ...cloneDeep(item),
              id: `${index + 1}_monthlog`,
              row_id: item.id,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
            }));

            item.contractData.map((rec) => {
              let index = month_contractData.findIndex((obj) => obj.contractId === rec.contractId && obj.cont_rowId === rec.cont_rowId);
              if (index === -1) {
                month_contractData.push(rec);
              }
              // else {
              //   month_contractData[index].quantity = parseFloat(month_contractData[index].quantity) + parseFloat(rec.quantity);
              //   month_contractData[index].totalrate = parseFloat(month_contractData[index].totalrate) + parseFloat(rec.totalrate);
              // }
            });
          });

          let inbound = {
            id: 'inbound',
            label: `${data.data.inflightcontracts.length} Inbound Flights`,
            flight_count: data.data.inflightcontracts.length,
            flights: data.data.inflightcontracts,
            contractData: inbound_contractData.map((item, index) => ({
              ...item,
              id: `${index + 1}_daylog`,
              row_id: item.id,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
            })), // Need to add ids
            inboundStatistics: inboundStatistics,
          };
          let outbound = {
            id: 'outbound',
            label: `${data.data.outflightcontracts.length} Outbound Flights`,
            flight_count: data.data.outflightcontracts.length,
            flights: data.data.outflightcontracts,
            contractData: outbound_contractData.map((item, index) => ({
              ...item,
              id: `${index + 1}_daylog`,
              row_id: item.id,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
            })), // Need to Sum up all outbound data
            outboundStatistics: outboundStatistics,
          };
          let daylog = {
            id: 'daylog',
            label: `${data.data.daycontracts.length} Day Logs`,
            daylog_count: data.data.daycontracts.length, // Need to replace this with alldaylogs count
            daylogs: data.data.daycontracts,
            alldaylogs: data.data.daycontracts, // need to change this
            contractData: day_contractData.map((item, index) => ({
              ...item,
              id: `${index + 1}_daylog`,
              row_id: item.id,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
            })), // Need to Sum up all daylogs data
          };
          let monthlog = {
            id: 'monthlog',
            label: `${data.data.monthcontracts.length} Month Logs`,
            monthlog_count: 1,
            monthlogs: data.data.monthcontracts,
            allmonthlogs: data.data.monthcontracts, // need to change this
            contractData: month_contractData.map((item, index) => ({
              ...item,
              id: `${index + 1}_monthlog`,
              row_id: item.id,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
            })), // Need to Sum up all monthlogs data
          };

          let airline_data = {
            id: data.data?.airlinecontracts[0]?.label,
            label: `${parseInt(data.data.inflightcontracts.length) + parseInt(data.data.outflightcontracts.length)} ${(this.state.airlineCode + ' Flights')}`,
            flight_count: parseInt(data.data.inflightcontracts.length) + parseInt(data.data.outflightcontracts.length),
            inbound: inbound,
            outbound: outbound,
            contractData: data.data.airlinecontracts[0]?.contractData.map((item, index) => ({
              ...item,
              id: `${index + 1}_daylog`,
              row_id: item.id,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
            })) || [],
            daylog: daylog,
            monthlog: monthlog,
          };
          billingData.push(airline_data);
          let contractData = [];
          // let dayContractData = [];
          // let monthContractData = [];
          // let accord_id = null;
          // let accord_type = null;
          let daylogdata = [];
          let monthlogdata = [];
          if (billingData.length > 0) {
            // alcontractsData = billingData[0]?.contractData;
            contractData = billingData[0]?.contractData;
            // accord_id = billingData[0]?.id;
            // accord_type = 'airline';
            // dayContractData = billingData[0]?.daylog?.contractData;
            // monthContractData = billingData[0]?.monthlog?.contractData;
            daylogdata = billingData[0]?.daylog?.alldaylogs;
            monthlogdata = billingData[0]?.monthlog?.allmonthlogs;
          }
          // console.log('billingData', billingData);
          // console.log('flightdata', flightdata);
          // console.log('invoicedata', invoicedata);
          // console.log('daylogdata*************', daylogdata);
          // console.log('monthlogdata***********', monthlogdata);
          // console.log('contractData', contractData);
          // console.log('dayContractData', dayContractData);
          // console.log('monthContractData', monthContractData);
          // console.log('customReportOptions********************************88', customReportOptions);
          // flightdata = flightdata.map((item) => ({
          //   ...item,
          //   contractData: item.contractData.filter((contract) => contract.is_nonbillable !== true),
          // }));
          // if(!callType){
          this.setState({
            // flightdata: flightdata || [],
            // invoicedata: invoicedata || [],
            // billingData: billingData || [],
            // csvContracts: csvContracts || [],
            // daylogdata: daylogdata || [],
            // monthlogdata: monthlogdata || [],
            // alcontractsData: alcontractsData,
            // contractData: contractData || [],
            // dayContractData: dayContractData || [],
            // monthContractData: monthContractData || [],
            // invoice_info: invoice_info || null,
            // accord_id: accord_id,
            // accord_type: accord_type,
            customReportOptions: customReportOptions,
            contractData2: contractData,
            csvContracts: csvContracts,
            daylogdata2: daylogdata,
            monthlogdata2: monthlogdata,
            billingData2: billingData,
          }, () => {
            this.filter();
            if (this.state.billingFields.transit === 'inbound' || this.state.billingFields.transit === 'outbound') {
              this.filterData();
              if (callback) return callback(true, contractData, csvContracts, daylogdata, monthlogdata, billingData);
            } else {
              if (callback) return callback(true, contractData, csvContracts, daylogdata, monthlogdata, billingData);
            }
          });
          // } else {
          //   if (this.state.billingFields.transit === 'inbound' || this.state.billingFields.transit === 'outbound') {
          //     if (callback) return callback(true, contractData, csvContracts, daylogdata, monthlogdata, billingData);
          //   } else {
          //     if (callback) return callback(true, contractData, csvContracts, daylogdata, monthlogdata, billingData);
          //   }
          // }
        });
    } else {
      if (callback) return callback(true);
    }
  };

  fetchContractData = () => {
    let flightdata = [];
    let daylogdata = [];
    let monthlogdata = [];
    let from = moment(this.state.searchFields.from).format('YYYY-MM-DD');
    let to = moment(this.state.searchFields.to).format('YYYY-MM-DD');
    if (this.state.searchFields.month) {
      if (this.state.searchFields.period === 'month') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      } else if (this.state.searchFields.period === 'first') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(14, 'days').format('YYYY-MM-DD');
      } else {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(15, 'days').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      }
    }
    if (this.state.searchFields.airline) {
      http.get(`/billing_contract?from=${from}&to=${to}&station=${this.station_code}&airline=${this.state.searchFields.airline}&type=${this.state.cont_item}`)
        .then(({ data }) => {
          // console.log('setting flightList 3');
          // this.setState({ flightList: data.data });
          if (data.data && data.data.length > 0) {
            let billingData = [];
            data.data.forEach((airline) => {

              let inbound = {};
              let outbound = {};
              let inbound_data = [];
              let outbound_data = [];

              let ib_flight_count = 0;
              if (airline?.inbound?.length > 0) {
                ib_flight_count = parseInt(airline?.inbound?.length);
                airline?.inbound.map((inflight) => {
                //map through inflight contracts and create array of contractsData
                  let contractsData = [];
                  let totalfltamt = 0;
                  if (inflight?.contracts?.length > 0) {
                    inflight?.contracts.map((contract) => {
                      if(contract.contractrows && contract?.contractrows.length > 0){
                        contract.contractrows.map((row) => {
                          totalfltamt += row.totalrate;
                          let [driver, source] = row.applied_on.split('|').map(s => s.trim());
                          let contractData = {
                            key: row.id,
                            id: row.id,
                            item: row.description,
                            driver: driver,
                            source: source,//Auto manual
                            quantity: row?.quantity,
                            rate: row?.rate_type === 'stable' ? row?.rate : 'Tiered Rate',
                            totalrate: row?.rate_type === 'stable' ? row.totalrate : 'Tiered Rate'
                          };
                          contractsData.push(contractData);
                        });
                      }
                    });
                    console.log('contractsData', contractsData);
                    console.log('totalfltamt', totalfltamt);
                  }
                  let flight = {
                    id: inflight?.id,
                    flight_no: inflight?.flight_no,
                    label:`${airline?.code}${inflight?.flight_no}/${moment(inflight?.flight_date,'YYYY-MM-DD').format('DDMMMYY')}`,
                    url:`/flight_folder/notes?id=${inflight.id}`,
                    flight_count: 1,
                    contractData: contractsData,
                    totalfltamt: '-',
                    pending: inflight?.pending,
                  };
                  inbound_data.push(flight);
                });
              }
              let incontractsData = [];
              if ( airline.inboundcontracts && airline.inboundcontracts?.length > 0 ) {
                airline.inboundcontracts.map((contract) => {
                  if(contract.contractrows && contract?.contractrows.length > 0){
                    contract.contractrows.map((row) => {
                      let [driver, source] = row.applied_on.split('|').map(s => s.trim());
                      let contractData = {
                        key: row.id,
                        id: row.id,
                        item: row.description,
                        driver: driver,
                        source: source,//Auto manual
                        quantity: row?.quantity || 0,
                        rate: row?.rate_type === 'stable' ? row?.rate : 'Tiered Rate',
                        totalrate: row?.rate_type === 'stable' ? row.totalrate : 'Tiered Rate'
                      };
                      incontractsData.push(contractData);
                    });
                  }
                });
                // console.log('contractsData',contractsData);
                // console.log('totalfltamt',totalfltamt);
              }
              flightdata = [...inbound_data];
              inbound = {
                id: `${airline?.id}_inbound`,
                label: `${ib_flight_count} Inbound Flights`,
                flight_count: ib_flight_count,
                flights: inbound_data,
                contractData: incontractsData,
              };


              let ob_flight_count = 0;
              if (airline?.outbound?.length > 0) {
                ob_flight_count = parseInt(airline?.outbound?.length);
                airline?.outbound.map((outflight) => {
                //map through inflight contracts and create array of contractsData
                  let contractsData = [];
                  let totalfltamt = 0;
                  if (outflight?.contracts?.length > 0) {
                    outflight?.contracts.map((contract) => {
                      if(contract.contractrows && contract?.contractrows.length > 0){
                        contract.contractrows.map((row) => {
                          totalfltamt += row.totalrate;
                          let [driver, source] = row.applied_on.split('|').map(s => s.trim());
                          let contractData = {
                            key: row.id,
                            id: row.id,
                            item: row.description,
                            driver: driver,
                            source: source,//Auto manual
                            quantity: row?.quantity || 0,
                            // rate: row?.rate || 0,
                            // totalrate: row.totalrate
                            rate: row?.rate_type === 'stable' ? row?.rate : 'Tiered Rate',
                            totalrate: row?.rate_type === 'stable' ? row.totalrate : 'Tiered Rate'
                          };
                          contractsData.push(contractData);
                        });
                      }
                    });
                  }
                  let flight = {
                    id: outflight?.id,
                    flight_no: outflight?.flight_no,
                    label: `${airline?.code}${outflight?.flight_no}/${moment(outflight?.flight_date,'YYYY-MM-DD').format('DDMMMYY')}`,
                    url: `/flight_folder/notes?id=${outflight.id}`,
                    flight_count: 1,
                    contractData: contractsData,
                    totalfltamt: totalfltamt,
                    pending: outflight?.pending,
                  };
                  outbound_data.push(flight);
                });
              }
              let outcontractsData = [];
              if ( airline.outboundcontracts && airline.outboundcontracts?.length > 0 ) {
                airline.outboundcontracts.map((contract) => {
                  if(contract.contractrows && contract?.contractrows.length > 0){
                    contract.contractrows.map((row) => {
                      let [driver, source] = row.applied_on.split('|').map(s => s.trim());
                      let contractData = {
                        key: row.id,
                        id: row.id,
                        item: row.description,
                        driver: driver,
                        source: source,//Auto manual
                        quantity: row?.quantity || 0,
                        rate: row?.rate_type === 'stable' ? row?.rate : 'Tiered Rate',
                        totalrate: row?.rate_type === 'stable' ? row.totalrate : 'Tiered Rate'
                      };
                      outcontractsData.push(contractData);
                    });
                  }
                });
                // console.log('contractsData',contractsData);
                // console.log('totalfltamt',totalfltamt);
              }
              flightdata = [...flightdata, ...outbound_data];
              outbound = {
                id: `${airline?.id}_outbound`,
                label: `${ob_flight_count} Outbound Flights`,
                flight_count: ob_flight_count,
                flights: outbound_data,
                contractData: outcontractsData,
              };

              let alcontractsData = [];
              if ( airline.airlinecontracts && airline.airlinecontracts?.length > 0 ) {
                airline.airlinecontracts.map((contract) => {
                  if (contract.contractrows && contract?.contractrows.length > 0) {
                    contract.contractrows.map((row) => {
                      let rate = 0;
                      // let totalrate = 0
                      if(row?.rate_type === 'stable'){
                        rate = row?.rate;
                        // totalrate = row.quantity * row.rate
                      } else if ( row?.rate_type === 'absolute'){
                        rate = row?.rate;
                        // console.log('absolute ***************************************8')
                        // if(row?.contrates && row?.contrates.length > 0){
                        //   row.contrates.sort(
                        //     (a, b) =>
                        //       parseInt(a.level) - parseInt(b.level)
                        //   );
                        //   for (let i = 0; i < row.contrates.length; i++) {
                        //     console.log('row.contrates[i]', row.contrates[i])
                        //     if (
                        //       row.quantity <
                        //         parseInt(row.contrates[i].level) ||
                        //       i === row.contrates.length - 1
                        //     ) {
                        //       row.rate = parseFloat(
                        //         row.contrates[i].rate
                        //       );
                        //       // totalrate = parseFloat(row.quantity) * parseFloat(row.contrates[i].rate);
                        //       break;
                        //     }
                        //   }
                        // }
                      } else if ( row?.rate_type === 'progressive' ) {
                        rate = 'Tiered Rate';
                        // if(row?.contrates && row?.contrates.length > 0){
                        //   row.contrates.sort(
                        //     (a, b) =>
                        //       parseInt(a.level) - parseInt(b.level)
                        //   );
                        //   let rate1 = row.contrates[0] && row.contrates[0].rate? parseFloat(row.contrates[0].rate): 0;
                        //   let rate2 = row.contrates[1] && row.contrates[1].rate? parseFloat(row.contrates[1].rate): 0;
                        //   let rate3 = row.contrates[2] && row.contrates[2].rate? parseFloat(row.contrates[2].rate): 0;
                        //   let level1 = row.contrates[0] && row.contrates[0].level? parseInt(row.contrates[0].level): 0;
                        //   let level2 = row.contrates[1] && row.contrates[1].level? parseInt(row.contrates[1].level): 0;
                        //   if (row.quantity <= level1 ||!rate2) {
                        //     rate = rate1;
                        //   } else if (row.quantity <= level2 ||!rate3) {
                        //     // rate = '('+String(rate1) + '$ * '+String(level1)+' + '+ String(rate2)+'$ * '+String(row.quantity - level1)+')';
                        //     rate = String(rate1)+'('+String(level1) +')\n'+String(rate2)+'('+String(row.quantity - level1) +')';
                        //   } else {
                        //     // rate = '('+String(rate1) + '$ * '+String(level1)+' + '+ String(rate2)+'$ * '+String(level2 - level1) + ' + '+ String(rate3)+'$ * '+String(row.quantity - level2)+')';
                        //     rate = String(rate1)+'('+String(level1) +')\n'+String(rate2)+'('+String(level2 - level1) +')\n'+String(rate3)+'('+String(row.quantity - level2) +')';
                        //   }
                        // }
                      }
                      let [driver, source] = row.applied_on.split('|').map(s => s.trim());
                      let contractData = {
                        key: row.id,
                        id: row.id,
                        item: row.description,
                        driver: driver,
                        source: source,//Auto manual
                        quantity: row?.quantity || 0,
                        rate: rate,
                        totalrate: parseFloat(row?.totalrate) || 0
                      };
                      alcontractsData.push(contractData);
                    });
                  }
                });
                // console.log('contractsData',contractsData);
                // console.log('totalfltamt',totalfltamt);
              }

              let daylog = {};
              let daylog_count = 0;
              let daylogs = [];
              let alldaylogs = [];
              let dcontractData = [];
              if ( airline.daycontracts && airline.daycontracts?.length > 0 ) {
                airline.daycontracts.map((contract) => {
                  if(contract.contractrows && contract?.contractrows.length > 0){
                    contract.contractrows.map((row) => {
                      let [driver, source] = row.applied_on.split('|').map(s => s.trim());
                      let obj = {
                        key: row.id,
                        id: row.id,
                        item: row.description,
                        driver: driver,
                        source: source,//Auto manual
                        quantity: row?.quantity || 0,
                        rate: row?.rate || 0,
                        totalrate: row.totalrate
                      };
                      dcontractData.push(obj);
                    });
                  }
                });
              }
              if (airline?.day_service_logs?.length > 0) {
                // sort day_service_logs by date
                airline?.day_service_logs.sort((a, b) => new Date(a.date) - new Date(b.date));
                daylog_count = parseInt(airline?.day_service_logs?.length);
                airline?.day_service_logs.map((daylog) => {
                  let ddcontractData = [];
                  if(daylog?.contracts?.length > 0){
                    daylog?.contracts.map((contract) => {
                      if(contract.contractrows && contract?.contractrows.length > 0){
                        contract.contractrows.map((row) => {
                          let [driver, source] = row.applied_on.split('|').map(s => s.trim());
                          let obj = {
                            key: row.id,
                            id: row.id,
                            item: row.description,
                            driver: driver,
                            source: source,//Auto manual
                            quantity: row?.quantity || 0,
                            rate: row?.rate || 0,
                            totalrate: row.totalrate
                          };
                          ddcontractData.push(obj);
                        });
                      }
                    });

                  }
                  let obj = {
                    id: daylog.id,
                    label: `${moment(daylog?.date,'YYYY-MM-DD').format('DDMMMYY')}`,
                    count: 1,
                    contractData: ddcontractData,
                  };
                  daylogs.push(obj);  

                });
                daylog = {
                  id: `${airline?.id}_daylog`,
                  label: `${daylog_count} Day Logs`,
                  daylog_count: daylog_count,
                  daylogs: daylogs,
                  contractData: dcontractData,
                };
              }
              if (airline?.allday_service_logs?.length > 0) {
                // sort allday_service_logs by date
                airline?.allday_service_logs.sort((a, b) => new Date(a.date) - new Date(b.date));
                daylog_count = parseInt(airline?.allday_service_logs?.length);
                airline?.allday_service_logs.map((daylog) => {
                  let obj = {
                    id: daylog.id,
                    label: `${moment(daylog?.date,'YYYY-MM-DD').format('DDMMMYY')}`,
                    count: 1,
                    contractData: [],
                    pending: daylog?.pending,
                  };
                  alldaylogs.push(obj);  
                });
                daylog = {
                  id: `${airline?.id}_daylog`,
                  label: `${daylog_count} Day Logs`,
                  daylog_count: daylog_count,
                  daylogs: daylogs,
                  alldaylogs: alldaylogs,
                  contractData: dcontractData,
                };
              }

              let monthlog = {};
              let monthlog_count = 0;
              let monthlogs = [];
              let mcontractData = [];
              if ( airline.monthcontracts && airline.monthcontracts?.length > 0 ) {
                airline.monthcontracts.map((contract) => {
                  if(contract.contractrows && contract?.contractrows.length > 0){
                    contract.contractrows.map((row) => {
                      let [driver, source] = row.applied_on.split('|').map(s => s.trim());
                      let obj = {
                        key: row.id,
                        id: row.id,
                        item: row.description,
                        driver: driver,
                        source: source,//Auto manual
                        quantity: row?.quantity || 0,
                        rate: row?.rate || 0,
                        totalrate: row.totalrate
                      };
                      mcontractData.push(obj);
                    });
                  }
                });
              }
              if (airline?.month_service_logs?.length > 0) {
                monthlog_count = parseInt(airline?.month_service_logs?.length);
                airline?.month_service_logs.map((monthlog) => {
                  let mmcontractData = [];
                  if(monthlog?.contracts?.length > 0){
                    monthlog?.contracts.map((contract) => {
                      if(contract.contractrows && contract?.contractrows.length > 0){
                        contract.contractrows.map((row) => {
                          let [driver, source] = row.applied_on.split('|').map(s => s.trim());
                          let obj = {
                            key: row.id,
                            id: row.id,
                            item: row.description,
                            driver: driver,
                            source: source,//Auto manual
                            quantity: row?.quantity || 0,
                            rate: row?.rate || 0,
                            totalrate: row.totalrate
                          };
                          mmcontractData.push(obj);
                        });
                      }
                    });

                  }
                  let obj = {
                    id: monthlog.id,
                    label: `${moment(monthlog?.date,'YYYY-MM-DD').format('MMMYY')}`,
                    count: 1,
                    contractData: mmcontractData,
                  };
                  monthlogs.push(obj);  

                });
                monthlog = {
                  id: `${airline?.id}_monthlog`,
                  label: `${monthlog_count} month Logs`,
                  monthlog_count: monthlog_count,
                  monthlogs: monthlogs,
                  contractData: mcontractData,
                };
              }
              
              let airline_data = {
                id: airline?.id,
                label: `${parseInt(ib_flight_count) + parseInt(ob_flight_count)} ${airline?.code} Flights`,
                sllabel: `${parseInt(monthlog_count) + parseInt(daylog_count)} ${airline?.code} Service Logs`,
                flight_count: ib_flight_count + ob_flight_count,
                // subRows: [inbound, outbound]
                inbound: inbound,
                outbound: outbound,
                alcontractsData: alcontractsData,
                contractData: [...mcontractData, ...dcontractData],
                daylog: daylog,
                monthlog: monthlog,
              };
              billingData.push(airline_data);

            });
            let alcontractsData = [];
            let contractData = [];
            let dayContractData = [];
            let monthContractData = [];
            let accord_id = null;
            let accord_type = null;
            if(billingData.length>0){
              alcontractsData = billingData[0]?.alcontractsData;
              contractData = billingData[0]?.contractData;
              accord_id = billingData[0]?.id;
              accord_type = 'airline';
              dayContractData = billingData[0]?.daylog?.contractData;
              monthContractData = billingData[0]?.monthlog?.contractData;
              daylogdata = billingData[0]?.daylog?.daylogs;
              monthlogdata = billingData[0]?.monthlog?.monthlogs;
            }
            // console.log('billingData',billingData);
            // console.log('flightdata',flightdata);
            // console.log('daylogdata*************',daylogdata);
            // console.log('monthlogdata***********',monthlogdata);
            // console.log('contractData',contractData);
            // console.log('dayContractData',dayContractData);
            // console.log('monthContractData',monthContractData);
            this.setState({ 
              billingData: billingData,
              flightdata: flightdata,
              daylogdata: daylogdata,
              monthlogdata: monthlogdata,
              alcontractsData: alcontractsData,
              contractData: contractData,
              dayContractData: dayContractData,
              monthContractData: monthContractData,
              accord_id: accord_id,
              accord_type: accord_type,
            }, () => {
              // if (this.state.billingFields.transit === 'inbound' || this.state.billingFields.transit === 'outbound') {
              //   this.filterData();
              // }
            });
          } else {
            this.setState({ billingData: [] });
          }
        });
    }
  };

  setContTBData = (data, type) => {
    this.setState({ 
      contractData: data?.contractData,
      accord_id: data?.id,
      accord_type: type,
    });
  };

  // onFilterMain = (e) => {
  //   let name = e.target.name;
  //   let value = e.target.value;
  //   this.setState((prev) => ({
  //     searchFields: {
  //       ...prev.searchFields,
  //       [name]: value
  //     }
  //   }), () => {
  //     if (e.target.name === 'airline') {
  //       let airlinecode = this.state.airlines.find((rec) => rec.id === value)?.code;
  //       this.setState({ airlineCode: airlinecode },()=>{
  //         this.fetchContractData();
  //       });
  //     } else {
  //       this.fetchContractData();
  //     }
  //   });
  // };

  handleContractType = (e) => {
    let cont_item = contractType[e.target.value];
    this.setState({ 
      contract_Type: e.target.value,
      cont_item: cont_item,
    },()=>{
      // this.fetchContractData();
      this.fetchInvoiceData();
    });
    //call function to filter by contracttype
  };
  
  onViewHistory = (data) => {
    this.setState({ 
      historyData: data,
      modalOpen: true
    });
  };
  onCloseHistory = () => {
    this.setState({ 
      historyData: [],
      modalOpen: false
    });
  };

  handleChange = (panel) => (e, newExpanded) => {
    this.setState({ expanded: newExpanded ? panel : !this.state.expanded });
  };

  handleDay = (e) => {
    let value = moment(e.target.value).format('YYYY-MM-DD');
    this.setState({ day: value });
  };

  handlePopover = (e) => {
    console.log(e);
    this.setState({ anchorEl: e?.currentTarget });
  };

  closePopover = () => {
    this.setState({ anchorEl: null });
  };

  progressCount = () => {
    this.setState((prevState) => {
      if (prevState.progress >= 100) {
        clearInterval(this.progressInterval);
        this.progressInterval = null; 
        return null; 
      }
      return { progress: prevState.progress + 10 };
    });
  };

  handleOpen = (modal) => {
    if(modal === 'downloadProgress') {
      // call PUT API verify_download_invoice/:id, if success start progress count. pass user id
      http.put(`/verify_download_invoice/${cookies.get('user')}`)
        .then((response) => {
          if(response.data.data.access === true) {
            if (this.progressInterval) clearInterval(this.progressInterval);
            this.progressInterval = setInterval(this.progressCount, 1000);
            this.setState({ modal });
          }
        });
    } else {
      this.setState({ modal });
    }
  };

  onClose = () => {
    clearInterval(this.interval);
    this.setState({ 
      modal: false,
      sessionExpired: false,
      emailPassword: false,
    });
  };

  startTimer = () => {
    if(cookies.get('expiryTimer')) {
      this.timer = setInterval(() => {
        const currentTime = moment.utc();
        const expirationTime = moment.utc(cookies.get('expiryTimer'));
        const timeDifference = expirationTime - currentTime;

        // Check if the timer has expired
        if (timeDifference <= 0) {
          cookies.remove('expiryTimer', { path: '/' });
          clearInterval(this.timer);
          this.setState({ sessionExpired: true });
          this.stopInterval();
        // Handle timer expiration
        } else {
        // Calculate remaining time
          const seconds = Math.floor((timeDifference / 1000) % 60) || 0;
          const minutes = Math.floor((timeDifference / 1000 / 60) % 60) || 0;
          const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24) || 0;
          const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24)) || 0;
          let sessionExpiryText = 'Session expires in ';
          let remainingTime = 0;
          if( (hours === 0 && minutes === 30 && seconds === 0 )|| (hours === 0 && minutes === 15 && seconds === 0)) {
            remainingTime = minutes;
            toast.warning(`${sessionExpiryText} ${remainingTime} minutes`);
          }
          this.setState({ timer: `Expires in ${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds` }
            // , ()=> {console.log(this.state.timer, 'timer');}
          );
        }
      }, 1000);
    }
  };
  stopInterval = () => {
    clearInterval(this.timer);
    clearInterval(this.state.timer);
    cookies.remove('expiryTimer', { path: '/' });
  };

  handleEmailPassword = () => {
    this.setState({ emailPassword: true });
  };
  
  filter = () => {
    const { filterData } = this.state;
    let filteredBillingData = cloneDeep(this.state.billingData2);
    let expanded = '';
    if (filterData.search) {
      const searchValue = filterData?.search.toLowerCase();
      const inboundMatches = filteredBillingData[0].inbound.flights.filter(item => item?.label?.toLowerCase().includes(searchValue));
      const outboundMatches = filteredBillingData[0].outbound.flights.filter(item => item?.label?.toLowerCase().includes(searchValue));
      if (inboundMatches.length > 0 && outboundMatches.length === 0) {
        filteredBillingData[0].inbound.flights = inboundMatches;
        filteredBillingData[0].outbound.flights = [];
        expanded = 'inbound';
      } else if (outboundMatches.length > 0 && inboundMatches.length === 0) {
        filteredBillingData[0].outbound.flights = outboundMatches;
        filteredBillingData[0].inbound.flights = [];
        expanded = 'outbound';
      } else if (inboundMatches.length > 0 && outboundMatches.length > 0) {
        filteredBillingData[0].inbound.flights = inboundMatches;
        filteredBillingData[0].outbound.flights = outboundMatches;
        expanded = 'none';
      } else {
        filteredBillingData[0].inbound.flights = [];
        filteredBillingData[0].outbound.flights = [];
        expanded = 'none';
      }
    }
    this.setState({
      filteredBillingData,
      expandedFlight: filterData.search ? 'flight' : '',
      expanded: expanded,
    });
  };

  handleReportChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState((prev) => ({
      reportFields: {
        ...prev.reportFields,
        [name]: value
      }
    }));
  };

  onModalOpen = (modal) => {
    this.setState({ modal });
  };

  handleCustomReportSelect = (type, value) => {
    if (type === 'Tonnage Summary') {
      this.setState({ tonSumOpts: value } );
    } else if (type === 'Flight Summary') {
      this.setState({ flightSumOpts: value } );
    } else if (type === 'Flight Details') {
      this.setState({ flightDetOpts: value } );
    }
  };

  render() {
    return (
      <>  
        <ServiceLog
          genInvProgress={this.props.genInvProgress}
          serviceLog={this.state.serviceLog}
          historyData={this.state.historyData}
          modalOpen={this.state.modalOpen}
          expanded={this.state.expanded}
          searchFields={this.state.searchFields}
          cont_item={this.state.cont_item}
          airlines={this.state.airlines}
          day={this.state.day}
          contract_Type={this.state.contract_Type}
          billingData={this.state.billingData}
          billingData2={this.state.billingData2}
          alcontractsData={this.state.alcontractsData}
          contractData={this.state.contractData}
          flightdata={this.state.flightdata}
          daylogdata={this.state.daylogdata}
          monthlogdata={this.state.monthlogdata}
          dayContractData={this.state.dayContractData}
          monthContractData={this.state.monthContractData}
          invoice_info={this.state.invoice_info}
          airlineCode={this.state.airlineCode}

          fetchInvoiceData={this.fetchInvoiceData}
          triggerNewBilling={this.triggerNewBilling}
          onViewHistory={this.onViewHistory}
          onCloseHistory={this.onCloseHistory}
          handleChange={this.handleChange}
          handleDay={this.handleDay} 
          // onFilterMain={this.onFilterMain}
          // flightFields={this.props.flightFields}
          handleContractType={this.handleContractType}
          setContTBData={this.setContTBData}
          accord_id={this.state.accord_id}
          accord_type={this.state.accord_type}
          handlePopover={this.handlePopover}
          closePopover={this.closePopover}
          anchorEl={this.state.anchorEl}

          handleOpen={this.handleOpen}
          handleEmailPassword={this.handleEmailPassword}
          emailPassword={this.state.emailPassword}
          modal={this.state.modal}
          progress={this.state.progress}
          onClose={this.onClose}

          expiryTimer={this.state.timer}
          sessionExpired={this.state.sessionExpired}
          startTimer={this.startTimer}
          stopInterval={this.stopInterval}

          customReportOptions={this.state.customReportOptions}
          tonSumOpts={this.state.tonSumOpts}
          flightSumOpts={this.state.flightSumOpts}
          flightDetOpts={this.state.flightDetOpts}
          reportFields={this.state.reportFields}
          handleReportChange={this.handleReportChange}
          onModalOpen={this.onModalOpen}
          handleCustomReportSelect={this.handleCustomReportSelect}
          handleExport={() =>
            handleExport(
              this.state.contractData,
              this.state.billingFields,
              this.state.billingData2,
              this.state.flightList,
              this.state.csvContracts,
              this.state.reportFields,
              this.state.flightSumOpts,
              this.state.flightDetOpts,
              this.state.tonSumOpts,
              this.state.daylogdata, 
              this.state.monthlogdata,
              this.state.billingColumns,
              {
                ...this.state.searchFields,
                airlineCode: this.state.airlineCode 
              },
              this.fetchInvoiceData2.bind(this),
              this.fetchProducts.bind(this),
              this.fetchDiscrepancies.bind(this),
              this.state.invoicedata,
              this.state.statisticsSummary
            )
          }
        />
      </>
    );
  }
}

// export default ServiceLogContainer;
export default (forwardRef((props, ref) => <ServiceLogContainer {...props} ref={ref} />));
